// @flow

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {|
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any,
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any,
  DecimalScalar: any,
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any,
  DecimalStringScalar: any,
  DateTimeStringScalar: any,
  DateStringScalar: any,
|};

export type Query = {|
  __typename?: 'Query',
  activeSubscription?: ?Subscription,
  affiliateReferralLink?: ?$ElementType<Scalars, 'String'>,
  annualPayslip?: ?AnnualPayslipType,
  annualReportsStartYear?: ?$ElementType<Scalars, 'Int'>,
  annualReportsTimeline?: ?Array<?IncomeTaxReportType>,
  annualVatReport?: ?AnnualVatReportType,
  autoRecord?: ?AutoRecordType,
  bankProviders?: ?Array<?BankProviderType>,
  businessIntercomLink?: ?$ElementType<Scalars, 'String'>,
  businessLegalTypes?: ?Array<?$ElementType<Scalars, 'String'>>,
  convertCurrency?: ?$ElementType<Scalars, 'DecimalScalar'>,
  couponText?: ?$ElementType<Scalars, 'String'>,
  currentBusiness?: ?BusinessType,
  currentUser?: ?UserType,
  customerCardSetupIntentSecret?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  expenseCategories?: ?Array<?ExpenseCategory>,
  failedPayment?: ?Payment,
  firstVatSubmissionDeadline?: ?$ElementType<Scalars, 'Date'>,
  GetLatestDataExport?: ?GetLatestDataExportPayload,
  id: $ElementType<Scalars, 'ID'>,
  incomeTaxReport?: ?IncomeTaxReportType,
  invoice?: ?InvoiceType,
  invoiceSettings?: ?InvoiceSettingsType,
  isFirstLogin?: ?$ElementType<Scalars, 'Boolean'>,
  isFirstSession?: ?$ElementType<Scalars, 'Boolean'>,
  isReportsSupportedForBusinessLegalType?: ?$ElementType<Scalars, 'Boolean'>,
  latestSubscription?: ?Subscription,
  paymentMethod?: ?CreditCard,
  payslipLines?: ?$ElementType<Scalars, 'JSONString'>,
  pnlReport?: ?PnlReportType,
  possibleBusinessesToAssume?: ?BusinessTypeConnection,
  record?: ?RecordType,
  referralCodeToDistribute?: ?$ElementType<Scalars, 'String'>,
  reportsTimeline?: ?Array<?ReportsUnion>,
  shouldPayVatInYear?: ?$ElementType<Scalars, 'Boolean'>,
  showAffiliateProgram?: ?$ElementType<Scalars, 'Boolean'>,
  stripeTaxAdvisorDashboardLink?: ?$ElementType<Scalars, 'String'>,
  supportedCurrencies?: ?Array<?Currency>,
  supportedVatExemptionParagraphs?: ?Array<?VatExemptionParagraph>,
  tapfiliateDashboardInitialPassword?: ?$ElementType<Scalars, 'String'>,
  taxNumberFormat?: ?$ElementType<Scalars, 'String'>,
  taxOffice?: ?TaxOfficeType,
  taxOfficeFromTaxNumber?: ?TaxOfficeType,
  taxOffices?: ?Array<?TaxOfficeType>,
  taxServiceBillingData?: ?TaxServiceBillingDataType,
  taxServiceBillings?: ?TaxServiceBillingTypeConnection,
  taxServicesBillingData?: ?Array<?TaxServiceBillingDataType>,
  taxStates?: ?Array<?$ElementType<Scalars, 'String'>>,
  userAssumingCapabilities?: ?$ElementType<Scalars, 'String'>,
  userSettings?: ?UserSettingsType,
  validatePersonalTaxId?: ?$ElementType<Scalars, 'Boolean'>,
  validateTaxNumber?: ?$ElementType<Scalars, 'Boolean'>,
  validateVatNumber?: ?$ElementType<Scalars, 'Boolean'>,
  vatReport?: ?VatReportType,
  yearlyChildInfo?: ?YearlyChildInfoType,
  zmReport?: ?ZmReportType,
|};


export type QueryAnnualPayslipArgs = {|
  id?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryAnnualVatReportArgs = {|
  year: $ElementType<Scalars, 'Int'>,
|};


export type QueryAutoRecordArgs = {|
  autoRecordId?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryBusinessIntercomLinkArgs = {|
  id?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryConvertCurrencyArgs = {|
  amount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  baseCurrency?: ?$ElementType<Scalars, 'String'>,
  date?: ?$ElementType<Scalars, 'Date'>,
  destCurrency?: ?$ElementType<Scalars, 'String'>,
|};


export type QueryDocumentArgs = {|
  id?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryGetLatestDataExportArgs = {|
  input: GetLatestDataExportInput,
|};


export type QueryIncomeTaxReportArgs = {|
  year: $ElementType<Scalars, 'Int'>,
|};


export type QueryInvoiceArgs = {|
  invoiceId?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryPnlReportArgs = {|
  year: $ElementType<Scalars, 'Int'>,
|};


export type QueryPossibleBusinessesToAssumeArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};


export type QueryRecordArgs = {|
  recordId?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryShouldPayVatInYearArgs = {|
  year?: ?$ElementType<Scalars, 'Int'>,
|};


export type QueryTaxNumberFormatArgs = {|
  taxState: $ElementType<Scalars, 'String'>,
|};


export type QueryTaxOfficeArgs = {|
  id?: ?$ElementType<Scalars, 'String'>,
|};


export type QueryTaxOfficeFromTaxNumberArgs = {|
  taxNumber: $ElementType<Scalars, 'String'>,
  taxState: $ElementType<Scalars, 'String'>,
|};


export type QueryTaxServiceBillingDataArgs = {|
  serviceType?: ?TaxServiceType,
|};


export type QueryTaxServiceBillingsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  state?: ?ServiceFeeState,
  state_In?: ?Array<?ServiceFeeState>,
|};


export type QueryUserSettingsArgs = {|
  setDefaultLanguage?: ?$ElementType<Scalars, 'String'>,
|};


export type QueryValidatePersonalTaxIdArgs = {|
  taxId: $ElementType<Scalars, 'String'>,
|};


export type QueryValidateTaxNumberArgs = {|
  taxNumber: $ElementType<Scalars, 'String'>,
  taxState: $ElementType<Scalars, 'String'>,
|};


export type QueryValidateVatNumberArgs = {|
  vatNumber: $ElementType<Scalars, 'String'>,
|};


export type QueryVatReportArgs = {|
  reportedPeriodStartDate: $ElementType<Scalars, 'Date'>,
|};


export type QueryYearlyChildInfoArgs = {|
  id?: ?$ElementType<Scalars, 'ID'>,
|};


export type QueryZmReportArgs = {|
  reportedPeriodStartDate: $ElementType<Scalars, 'Date'>,
|};

export type Subscription = {|
  __typename?: 'Subscription',
  cancelAtDate?: ?$ElementType<Scalars, 'String'>,
  canceledAtDate?: ?$ElementType<Scalars, 'String'>,
  creditCard?: ?CreditCard,
  endDate?: ?$ElementType<Scalars, 'String'>,
  isActive?: ?$ElementType<Scalars, 'Boolean'>,
  isLegacyYearlySubscription?: ?$ElementType<Scalars, 'Boolean'>,
  isSubscriptionCanceled?: ?$ElementType<Scalars, 'Boolean'>,
  name?: ?$ElementType<Scalars, 'String'>,
  nextPaymentDate?: ?$ElementType<Scalars, 'String'>,
  paymentAmount?: ?$ElementType<Scalars, 'String'>,
  startDate?: ?$ElementType<Scalars, 'String'>,
|};

export type CreditCard = {|
  __typename?: 'CreditCard',
  brand?: ?$ElementType<Scalars, 'String'>,
  last4Digits?: ?$ElementType<Scalars, 'String'>,
|};

export type AnnualPayslipType = {|
  ...Node,
  ...{|
    __typename?: 'AnnualPayslipType',
    amounts?: ?$ElementType<Scalars, 'JSONString'>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    employeeContributionsToPension?: ?$ElementType<Scalars, 'DecimalScalar'>,
    employeeContributionsToPrivateHealthAndCareInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    employeeContributionsToPublicCareInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    employeeContributionsToPublicHealthInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    employeeContributionsToUnemploymentInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    endDate: $ElementType<Scalars, 'Date'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    incomeTaxReport: IncomeTaxReportType,
    isMainPartner: $ElementType<Scalars, 'Boolean'>,
    startDate: $ElementType<Scalars, 'Date'>,
    taxClass: $ElementType<Scalars, 'String'>,
    totalIncomeBeforeTax: $ElementType<Scalars, 'DecimalScalar'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};

/** An object with an ID */
export type Node = {|
  /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
|};





export type IncomeTaxReportType = {|
  ...BaseReportInterface,
  ...Node,
  ...ReportPeriodInterface,
  ...{|
    __typename?: 'IncomeTaxReportType',
    allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
    annualPayslips: AnnualPayslipTypeConnection,
    annualVatReport?: ?AnnualVatReportType,
    business: BusinessType,
    children: YearlyChildInfoTypeConnection,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    data?: ?$ElementType<Scalars, 'JSONString'>,
    estimatedTaxAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isFormValid?: ?$ElementType<Scalars, 'Boolean'>,
    isFormValidExceptIncomeFromPnl?: ?$ElementType<Scalars, 'Boolean'>,
    isJointAssessment?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    mainPartner?: ?IncomeTaxReportPartnerType,
    pageData?: ?$ElementType<Scalars, 'JSONString'>,
    pagesValidity?: ?$ElementType<Scalars, 'JSONString'>,
    pagesValidityRaw?: ?$ElementType<Scalars, 'JSONString'>,
    paidAddOns?: ?$ElementType<Scalars, 'JSONString'>,
    periodStartDate?: ?$ElementType<Scalars, 'Date'>,
    pnlReport?: ?PnlReportType,
    prepaymentAmounts?: ?$ElementType<Scalars, 'JSONString'>,
    ratedNonTaxableIncomeAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    remainingTaxToBePaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    reportingInterval?: ?VatReportingInterval,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    sentToTaxAdvisor?: ?$ElementType<Scalars, 'Boolean'>,
    sentToTaxAdvisorOnDate?: ?$ElementType<Scalars, 'DateTime'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    shouldAskIfReportSubmittedAlready?: ?$ElementType<Scalars, 'Boolean'>,
    shouldStartChargingVatNextYear?: ?$ElementType<Scalars, 'Boolean'>,
    spouse?: ?IncomeTaxReportPartnerType,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
    sumOfTaxableIncome?: ?$ElementType<Scalars, 'DecimalScalar'>,
    taxableItems?: ?$ElementType<Scalars, 'JSONString'>,
    taxComponentAmounts?: ?$ElementType<Scalars, 'JSONString'>,
    totalEmployeeAdvancePayments?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalIncome?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalTaxableExpenses?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalTaxPaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalTaxPayments?: ?$ElementType<Scalars, 'DecimalScalar'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    year: $ElementType<Scalars, 'Int'>,
  |}
|};


export type IncomeTaxReportTypeAnnualPayslipsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type IncomeTaxReportTypeChildrenArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type IncomeTaxReportTypePageDataArgs = {|
  pageName?: ?$ElementType<Scalars, 'String'>,
|};

export type BaseReportInterface = {|
  confirmationDocument?: ?DocumentType,
  hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
  id: $ElementType<Scalars, 'ID'>,
  isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
  isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
  isSent?: ?$ElementType<Scalars, 'Boolean'>,
  reportedDate?: ?$ElementType<Scalars, 'Date'>,
  requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
  sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
  submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
|};

export type DocumentType = {|
  ...Node,
  ...{|
    __typename?: 'DocumentType',
    annualvatreportSet: AnnualVatReportTypeConnection,
    autoExtractedRecord?: ?AutoRecordType,
    autorecords: AutoRecordTypeConnection,
    bigThumbnailUrl?: ?$ElementType<Scalars, 'String'>,
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    documentUrl?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    incometaxreportSet: IncomeTaxReportTypeConnection,
    invoices: InvoiceTypeConnection,
    ocrText: $ElementType<Scalars, 'String'>,
    pnlreportSet: PnlReportTypeConnection,
    rawExtractedFields?: ?$ElementType<Scalars, 'JSONString'>,
    records: RecordTypeConnection,
    taxregistrationSet: TaxRegistrationTypeConnection,
    thumbnailUrl?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatreportSet: VatReportTypeConnection,
    zmreportSet: ZmReportTypeConnection,
  |}
|};


export type DocumentTypeAnnualvatreportSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeAutorecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeIncometaxreportSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeInvoicesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypePnlreportSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeTaxregistrationSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeVatreportSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type DocumentTypeZmreportSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type AnnualVatReportTypeConnection = {|
  __typename?: 'AnnualVatReportTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?AnnualVatReportTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `AnnualVatReportType` and its cursor. */
export type AnnualVatReportTypeEdge = {|
  __typename?: 'AnnualVatReportTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?AnnualVatReportType,
|};

export type AnnualVatReportType = {|
  ...BaseReportInterface,
  ...BaseVatReportInterface,
  ...Node,
  ...ReportPeriodInterface,
  ...VatReportInterface,
  ...{|
    __typename?: 'AnnualVatReportType',
    advanceReports?: ?VatReportTypeConnection,
    advanceVatAmountBalance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    advanceVatPaid?: ?AdvanceVatPaymentDataType,
    advanceVatRefund?: ?AdvanceVatPaymentDataType,
    advanceVatReportReportingInterval?: ?VatReportingInterval,
    allLines?: ?Array<?VatReportLineType>,
    allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
    business?: ?BusinessType,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    expensesWithoutAttributionToVatExemptRevenue?: ?RecordTypeConnection,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    invoicesWithoutTaxNumber?: ?RecordTypeConnection,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    paymentReference?: ?$ElementType<Scalars, 'String'>,
    periodStartDate?: ?$ElementType<Scalars, 'Date'>,
    previousYearReport?: ?AnnualVatReportType,
    remainingTaxToBePaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportedAdvanceVatAmountBalance?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    reportedTotalNetRevenue?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportedTotalVatAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportingInterval?: ?VatReportingInterval,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    revenueForSmallBusinessOwnerThreshold?: ?$ElementType<Scalars, 'DecimalScalar'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    shouldPayVatInYear?: ?$ElementType<Scalars, 'Boolean'>,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
    totalNetRevenue?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalVatAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalVatToBePaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
    unpaidRecords?: ?RecordTypeConnection,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    year: $ElementType<Scalars, 'Int'>,
  |}
|};


export type AnnualVatReportTypeAdvanceReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type AnnualVatReportTypeExpensesWithoutAttributionToVatExemptRevenueArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type AnnualVatReportTypeInvoicesWithoutTaxNumberArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type AnnualVatReportTypeUnpaidRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type BaseVatReportInterface = {|
  expensesWithoutAttributionToVatExemptRevenue?: ?RecordTypeConnection,
  invoicesWithoutTaxNumber?: ?RecordTypeConnection,
  unpaidRecords?: ?RecordTypeConnection,
|};


export type BaseVatReportInterfaceExpensesWithoutAttributionToVatExemptRevenueArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BaseVatReportInterfaceInvoicesWithoutTaxNumberArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BaseVatReportInterfaceUnpaidRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type RecordTypeConnection = {|
  __typename?: 'RecordTypeConnection',
  convertedGrossAmountSum?: ?$ElementType<Scalars, 'DecimalScalar'>,
  count?: ?$ElementType<Scalars, 'Int'>,
  /** Contains the nodes in this connection. */
  edges: Array<?RecordTypeEdge>,
  exists?: ?$ElementType<Scalars, 'Boolean'>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `RecordType` and its cursor. */
export type RecordTypeEdge = {|
  __typename?: 'RecordTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?RecordType,
|};

export type RecordType = {|
  ...AbstractRecordInterface,
  ...{|
    __typename?: 'RecordType',
    assetLifetimeValue?: ?$ElementType<Scalars, 'Int'>,
    business?: ?BusinessType,
    businessTripMealAccommodationCountry?: ?$ElementType<Scalars, 'String'>,
    category?: ?$ElementType<Scalars, 'String'>,
    convertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    counterPartyCountry?: ?$ElementType<Scalars, 'String'>,
    counterPartyVatNumber?: ?$ElementType<Scalars, 'String'>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    currency?: ?$ElementType<Scalars, 'String'>,
    currencyConversionRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
    date?: ?$ElementType<Scalars, 'Date'>,
    deductibleConvertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    deductibleGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    depreciationAmounts?: ?$ElementType<Scalars, 'JSONString'>,
    description?: ?$ElementType<Scalars, 'String'>,
    document?: ?DocumentType,
    expectedLocalVatRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
    expenseAttributionToVatExemptRevenue?: ?ExpenseAttributionToVatExemptRevenue,
    flatRateExpenseEndDate?: ?$ElementType<Scalars, 'Date'>,
    flatRateExpenseStartDate?: ?$ElementType<Scalars, 'Date'>,
    grossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    grossAmountCurrency: RecordGrossAmountCurrency,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    inputChannel?: ?InputChannelEnum,
    invoice?: ?InvoiceType,
    isBasedOnInternalCreatedInvoice?: ?$ElementType<Scalars, 'Boolean'>,
    isCustomerPrivatePerson?: ?$ElementType<Scalars, 'Boolean'>,
    isHomeOffice?: ?$ElementType<Scalars, 'Boolean'>,
    isOfficeMaintenance?: ?$ElementType<Scalars, 'Boolean'>,
    isServiceOrGoods?: ?$ElementType<Scalars, 'String'>,
    linkedAutoRecords: AutoRecordTypeConnection,
    netAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    netDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
    otherTaxesCharged?: ?$ElementType<Scalars, 'Boolean'>,
    partialRecordSourceCategoryType?: ?PartialRecordSourceCategoryEnum,
    paymentMonth?: ?$ElementType<Scalars, 'Date'>,
    paymentStatus?: ?$ElementType<Scalars, 'String'>,
    privateCarDistanceDriven?: ?$ElementType<Scalars, 'Int'>,
    privateCarDriveToWorkTotalDays?: ?$ElementType<Scalars, 'Int'>,
    privateCarUsageType?: ?$ElementType<Scalars, 'String'>,
    recordType?: ?$ElementType<Scalars, 'String'>,
    recurringSettingSource?: ?RecurringRecordSettingType,
    repeatInterval?: ?$ElementType<Scalars, 'String'>,
    reverseChargeApply?: ?$ElementType<Scalars, 'Boolean'>,
    reverseChargeNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    shouldLink?: ?$ElementType<Scalars, 'Boolean'>,
    totalVat?: ?$ElementType<Scalars, 'DecimalScalar'>,
    uid?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vat?: ?$ElementType<Scalars, 'JSONString'>,
    vatDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
    vatExemptionParagraph?: ?VatExemptionParagraph,
    vatPaymentPeriodInterval?: ?VatReportingInterval,
    vatReport?: ?VatReportType,
    zmReport?: ?ZmReportType,
  |}
|};


export type RecordTypeLinkedAutoRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type AbstractRecordInterface = {|
  assetLifetimeValue?: ?$ElementType<Scalars, 'Int'>,
  business?: ?BusinessType,
  businessTripMealAccommodationCountry?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  convertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  counterPartyCountry?: ?$ElementType<Scalars, 'String'>,
  counterPartyVatNumber?: ?$ElementType<Scalars, 'String'>,
  currency?: ?$ElementType<Scalars, 'String'>,
  currencyConversionRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
  date?: ?$ElementType<Scalars, 'Date'>,
  deductibleConvertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  deductibleGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  depreciationAmounts?: ?$ElementType<Scalars, 'JSONString'>,
  description?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  expectedLocalVatRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
  expenseAttributionToVatExemptRevenue?: ?ExpenseAttributionToVatExemptRevenue,
  flatRateExpenseEndDate?: ?$ElementType<Scalars, 'Date'>,
  flatRateExpenseStartDate?: ?$ElementType<Scalars, 'Date'>,
  grossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
  inputChannel?: ?InputChannelEnum,
  invoice?: ?InvoiceType,
  isCustomerPrivatePerson?: ?$ElementType<Scalars, 'Boolean'>,
  isHomeOffice?: ?$ElementType<Scalars, 'Boolean'>,
  isOfficeMaintenance?: ?$ElementType<Scalars, 'Boolean'>,
  isServiceOrGoods?: ?$ElementType<Scalars, 'String'>,
  netAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  netDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
  otherTaxesCharged?: ?$ElementType<Scalars, 'Boolean'>,
  partialRecordSourceCategoryType?: ?PartialRecordSourceCategoryEnum,
  paymentMonth?: ?$ElementType<Scalars, 'Date'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  privateCarDistanceDriven?: ?$ElementType<Scalars, 'Int'>,
  privateCarDriveToWorkTotalDays?: ?$ElementType<Scalars, 'Int'>,
  privateCarUsageType?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recurringSettingSource?: ?RecurringRecordSettingType,
  repeatInterval?: ?$ElementType<Scalars, 'String'>,
  reverseChargeApply?: ?$ElementType<Scalars, 'Boolean'>,
  reverseChargeNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  shouldLink?: ?$ElementType<Scalars, 'Boolean'>,
  uid?: ?$ElementType<Scalars, 'String'>,
  vat?: ?$ElementType<Scalars, 'JSONString'>,
  vatDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
  vatExemptionParagraph?: ?VatExemptionParagraph,
  vatPaymentPeriodInterval?: ?VatReportingInterval,
|};

export type BusinessType = {|
  ...BusinessBankAccountQuery,
  ...Node,
  ...{|
    __typename?: 'BusinessType',
    address?: ?$ElementType<Scalars, 'JSONString'>,
    addressForDisplay?: ?$ElementType<Scalars, 'String'>,
    annualVatReports: AnnualVatReportTypeConnection,
    assignedTaxAdvisor?: ?TaxAdvisorType,
    autorecords?: ?AutoRecordTypeConnection,
    bankAccounts?: ?Array<?BankAccountType>,
    bankConnections?: ?Array<?BankConnectionType>,
    businessLegalType?: ?$ElementType<Scalars, 'String'>,
    businessPerformance?: ?BusinessPerformanceType,
    businessVatExemptionParagraphs?: ?Array<?VatExemptionParagraph>,
    companyName?: ?$ElementType<Scalars, 'String'>,
    completedOnboardingSteps: Array<$ElementType<Scalars, 'String'>>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    customers?: ?BusinessCustomerTypeConnection,
    defaultCurrency: $ElementType<Scalars, 'String'>,
    defaultVatExemptionParagraph?: ?VatExemptionParagraph,
    documents?: ?DocumentTypeConnection,
    experiments?: ?ExperimentTypeConnection,
    failedBankConnectionsCount?: ?$ElementType<Scalars, 'Int'>,
    finishedOnboarding: $ElementType<Scalars, 'Boolean'>,
    formattedTaxNumber?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    incomeTaxReports: IncomeTaxReportTypeConnection,
    invoicePaymentMethods?: ?InvoicePaymentMethodTypeConnection,
    invoices: InvoiceTypeConnection,
    invoiceSettings?: ?InvoiceSettingsType,
    isAlertDismissed?: ?$ElementType<Scalars, 'Boolean'>,
    isSelfEmployedBeforeRegistrationYear?: ?$ElementType<Scalars, 'Boolean'>,
    latestYearlyConfig?: ?YearlyConfigType,
    name?: ?$ElementType<Scalars, 'String'>,
    overrideEmailForReports?: ?$ElementType<Scalars, 'String'>,
    owningUser?: ?UserType,
    pnlReport?: ?PnlReportType,
    pnlReports: PnlReportTypeConnection,
    profession?: ?$ElementType<Scalars, 'String'>,
    records?: ?RecordTypeConnection,
    referralCodeReceived?: ?$ElementType<Scalars, 'String'>,
    referralCodeSent?: ?$ElementType<Scalars, 'String'>,
    registeredTaxState?: ?$ElementType<Scalars, 'String'>,
    registeredWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    reportVatWhenNoRelevantIncomeAsSmallBusinessOwner?: ?$ElementType<Scalars, 'Boolean'>,
    saltedgeCustomerId?: ?$ElementType<Scalars, 'String'>,
    selfEmploymentEndDate?: ?$ElementType<Scalars, 'Date'>,
    selfEmploymentStartDate?: ?$ElementType<Scalars, 'Date'>,
    shouldShowSampleDocumentButtonExpense?: ?$ElementType<Scalars, 'Boolean'>,
    shouldShowSampleDocumentButtonIncome?: ?$ElementType<Scalars, 'Boolean'>,
    showTaxCredit: $ElementType<Scalars, 'Boolean'>,
    stripeCustomerId?: ?$ElementType<Scalars, 'String'>,
    submittedAdvanceVatReport?: ?$ElementType<Scalars, 'Boolean'>,
    submittedZmReport?: ?$ElementType<Scalars, 'Boolean'>,
    tapfiliateDashboardInitialPassword?: ?$ElementType<Scalars, 'String'>,
    taxNeedsOnboardingQuestion?: ?TaxNeeds,
    taxNumber?: ?$ElementType<Scalars, 'String'>,
    taxOffice?: ?TaxOfficeType,
    taxOfficeId?: ?$ElementType<Scalars, 'String'>,
    taxRegistration?: ?TaxRegistrationType,
    taxRegistrationForMainPage?: ?TaxRegistrationType,
    taxServiceBillings?: ?TaxServiceBillingTypeConnection,
    triedToConnectBankAccount?: ?$ElementType<Scalars, 'Boolean'>,
    unsupportedBankAccounts?: ?UnsupportedBankAccountTypeConnection,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatNumber?: ?$ElementType<Scalars, 'String'>,
    vatReports: VatReportTypeConnection,
    vatReportsStartDate?: ?$ElementType<Scalars, 'Date'>,
    yearlyConfigs: YearlyConfigTypeConnection,
    zmReports: ZmReportTypeConnection,
    zmReportStartDate?: ?$ElementType<Scalars, 'Date'>,
  |}
|};


export type BusinessTypeAnnualVatReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeAssignedTaxAdvisorArgs = {|
  setDefaultLanguage?: ?$ElementType<Scalars, 'String'>,
|};


export type BusinessTypeAutorecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  date_Gte?: ?$ElementType<Scalars, 'Date'>,
  date_Lte?: ?$ElementType<Scalars, 'Date'>,
  dateYear?: ?$ElementType<Scalars, 'Int'>,
  excludeVatPayments?: ?$ElementType<Scalars, 'Boolean'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  idIn?: ?$ElementType<Scalars, 'String'>,
  isPendingApproval?: ?$ElementType<Scalars, 'Boolean'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  paymentDateOrDateYearLte?: ?$ElementType<Scalars, 'Int'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  recommendedRecordsForPendingAutoRecord?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recordType_In?: ?Array<?$ElementType<Scalars, 'String'>>,
  recurringSettingSource_Isnull?: ?$ElementType<Scalars, 'Boolean'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};


export type BusinessTypeBusinessPerformanceArgs = {|
  year?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeCustomersArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  displayName?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeDocumentsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeExperimentsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeIncomeTaxReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeInvoicePaymentMethodsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  isDefault?: ?$ElementType<Scalars, 'Boolean'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
|};


export type BusinessTypeInvoicesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeIsAlertDismissedArgs = {|
  alertName?: ?$ElementType<Scalars, 'String'>,
|};


export type BusinessTypeLatestYearlyConfigArgs = {|
  upToYear?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypePnlReportArgs = {|
  year: $ElementType<Scalars, 'Int'>,
|};


export type BusinessTypePnlReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  date_Gte?: ?$ElementType<Scalars, 'Date'>,
  date_Lte?: ?$ElementType<Scalars, 'Date'>,
  dateYear?: ?$ElementType<Scalars, 'Int'>,
  excludeVatPayments?: ?$ElementType<Scalars, 'Boolean'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  idIn?: ?$ElementType<Scalars, 'String'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  paymentDateOrDateYearLte?: ?$ElementType<Scalars, 'Int'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  recommendedRecordsForPendingAutoRecord?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recordType_In?: ?Array<?$ElementType<Scalars, 'String'>>,
  recurringSettingSource_Isnull?: ?$ElementType<Scalars, 'Boolean'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};


export type BusinessTypeTaxServiceBillingsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  state?: ?ServiceFeeState,
  state_In?: ?Array<?ServiceFeeState>,
|};


export type BusinessTypeUnsupportedBankAccountsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeVatReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeYearlyConfigsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type BusinessTypeZmReportsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type BusinessBankAccountQuery = {|
  bankAccounts?: ?Array<?BankAccountType>,
  bankConnections?: ?Array<?BankConnectionType>,
  failedBankConnectionsCount?: ?$ElementType<Scalars, 'Int'>,
  triedToConnectBankAccount?: ?$ElementType<Scalars, 'Boolean'>,
|};

export type BankAccountType = {|
  __typename?: 'BankAccountType',
  balance?: ?$ElementType<Scalars, 'DecimalStringScalar'>,
  currencyCode?: ?$ElementType<Scalars, 'String'>,
  iban?: ?$ElementType<Scalars, 'String'>,
  name?: ?$ElementType<Scalars, 'String'>,
  nature?: ?$ElementType<Scalars, 'String'>,
|};


export type BankConnectionType = {|
  __typename?: 'BankConnectionType',
  autoRecords?: ?AutoRecordTypeConnection,
  bankAccounts?: ?Array<?BankAccountType>,
  categorization?: ?BankProviderCategorization,
  createdAt?: ?$ElementType<Scalars, 'DateTimeStringScalar'>,
  id: $ElementType<Scalars, 'ID'>,
  isFailed?: ?$ElementType<Scalars, 'Boolean'>,
  lastAttempt?: ?BankAttemptType,
  lastSuccessAt?: ?$ElementType<Scalars, 'DateTimeStringScalar'>,
  nextRefreshPossibleAt?: ?$ElementType<Scalars, 'DateTimeStringScalar'>,
  provider?: ?BankProviderType,
  providerCode?: ?$ElementType<Scalars, 'String'>,
  providerName?: ?$ElementType<Scalars, 'String'>,
  status?: ?BankConnectionStatus,
|};


export type BankConnectionTypeAutoRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  date_Gte?: ?$ElementType<Scalars, 'Date'>,
  date_Lte?: ?$ElementType<Scalars, 'Date'>,
  dateYear?: ?$ElementType<Scalars, 'Int'>,
  excludeVatPayments?: ?$ElementType<Scalars, 'Boolean'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  idIn?: ?$ElementType<Scalars, 'String'>,
  isPendingApproval?: ?$ElementType<Scalars, 'Boolean'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  paymentDateOrDateYearLte?: ?$ElementType<Scalars, 'Int'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  recommendedRecordsForPendingAutoRecord?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recordType_In?: ?Array<?$ElementType<Scalars, 'String'>>,
  recurringSettingSource_Isnull?: ?$ElementType<Scalars, 'Boolean'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};

export type AutoRecordTypeConnection = {|
  __typename?: 'AutoRecordTypeConnection',
  convertedGrossAmountSum?: ?$ElementType<Scalars, 'DecimalScalar'>,
  count?: ?$ElementType<Scalars, 'Int'>,
  /** Contains the nodes in this connection. */
  edges: Array<?AutoRecordTypeEdge>,
  exists?: ?$ElementType<Scalars, 'Boolean'>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `AutoRecordType` and its cursor. */
export type AutoRecordTypeEdge = {|
  __typename?: 'AutoRecordTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?AutoRecordType,
|};

export type AutoRecordType = {|
  ...AbstractRecordInterface,
  ...{|
    __typename?: 'AutoRecordType',
    assetLifetimeValue?: ?$ElementType<Scalars, 'Int'>,
    business?: ?BusinessType,
    businessTripMealAccommodationCountry?: ?$ElementType<Scalars, 'String'>,
    category?: ?$ElementType<Scalars, 'String'>,
    convertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    counterPartyCountry?: ?$ElementType<Scalars, 'String'>,
    counterPartyVatNumber?: ?$ElementType<Scalars, 'String'>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    currency?: ?$ElementType<Scalars, 'String'>,
    currencyConversionRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
    date?: ?$ElementType<Scalars, 'Date'>,
    deductibleConvertedGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    deductibleGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    depreciationAmounts?: ?$ElementType<Scalars, 'JSONString'>,
    description?: ?$ElementType<Scalars, 'String'>,
    document?: ?DocumentType,
    expectedLocalVatRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
    expenseAttributionToVatExemptRevenue?: ?ExpenseAttributionToVatExemptRevenue,
    flatRateExpenseEndDate?: ?$ElementType<Scalars, 'Date'>,
    flatRateExpenseStartDate?: ?$ElementType<Scalars, 'Date'>,
    grossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    grossAmountCurrency: AutoRecordGrossAmountCurrency,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    inputChannel?: ?InputChannelEnum,
    invoice?: ?InvoiceType,
    isCustomerPrivatePerson?: ?$ElementType<Scalars, 'Boolean'>,
    isHomeOffice?: ?$ElementType<Scalars, 'Boolean'>,
    isOfficeMaintenance?: ?$ElementType<Scalars, 'Boolean'>,
    isPendingApproval: $ElementType<Scalars, 'Boolean'>,
    isServiceOrGoods?: ?$ElementType<Scalars, 'String'>,
    linkedToRecord?: ?RecordType,
    netAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    netDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
    otherTaxesCharged?: ?$ElementType<Scalars, 'Boolean'>,
    partialRecordSourceCategoryType?: ?PartialRecordSourceCategoryEnum,
    paymentMonth?: ?$ElementType<Scalars, 'Date'>,
    paymentStatus?: ?$ElementType<Scalars, 'String'>,
    privateCarDistanceDriven?: ?$ElementType<Scalars, 'Int'>,
    privateCarDriveToWorkTotalDays?: ?$ElementType<Scalars, 'Int'>,
    privateCarUsageType?: ?$ElementType<Scalars, 'String'>,
    recordType?: ?$ElementType<Scalars, 'String'>,
    recurringSettingSource?: ?RecurringRecordSettingType,
    repeatInterval?: ?$ElementType<Scalars, 'String'>,
    reverseChargeApply?: ?$ElementType<Scalars, 'Boolean'>,
    reverseChargeNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    shouldLink?: ?$ElementType<Scalars, 'Boolean'>,
    totalVat?: ?$ElementType<Scalars, 'DecimalScalar'>,
    uid?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vat?: ?$ElementType<Scalars, 'JSONString'>,
    vatDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
    vatExemptionParagraph?: ?VatExemptionParagraph,
    vatPaymentPeriodInterval?: ?VatReportingInterval,
    vatReport?: ?VatReportType,
    zmReport?: ?ZmReportType,
  |}
|};

export const ExpenseAttributionToVatExemptRevenueValues = Object.freeze({
  NonVatExemptionRelated: 'non_vat_exemption_related',
  PartiallyVatExemptionRelated: 'partially_vat_exemption_related',
  VatExemptionRelated: 'vat_exemption_related'
});


export type ExpenseAttributionToVatExemptRevenue = $Values<typeof ExpenseAttributionToVatExemptRevenueValues>;

export const AutoRecordGrossAmountCurrencyValues = Object.freeze({
  /** UAE Dirham */
  Aed: 'AED',
  /** Afghani */
  Afn: 'AFN',
  /** Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Netherlands Antillian Guilder */
  Ang: 'ANG',
  /** Kwanza */
  Aoa: 'AOA',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Aruban Guilder */
  Awg: 'AWG',
  /** Azerbaijanian Manat */
  Azn: 'AZN',
  /** Convertible Marks */
  Bam: 'BAM',
  /** Barbados Dollar */
  Bbd: 'BBD',
  /** Taka */
  Bdt: 'BDT',
  /** Bulgarian Lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundi Franc */
  Bif: 'BIF',
  /** Bermudian Dollar (customarily known as Bermuda Dollar) */
  Bmd: 'BMD',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Boliviano */
  Bob: 'BOB',
  /** Mvdol */
  Bov: 'BOV',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Bahamian Dollar */
  Bsd: 'BSD',
  /** Bhutanese ngultrum */
  Btn: 'BTN',
  /** Pula */
  Bwp: 'BWP',
  /** Belarussian Ruble */
  Byn: 'BYN',
  /** Belarussian Ruble */
  Byr: 'BYR',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese franc */
  Cdf: 'CDF',
  /** WIR Euro */
  Che: 'CHE',
  /** Swiss Franc */
  Chf: 'CHF',
  /** WIR Franc */
  Chw: 'CHW',
  /** Unidad de Fomento */
  Clf: 'CLF',
  /** Chilean peso */
  Clp: 'CLP',
  /** Yuan Renminbi */
  Cny: 'CNY',
  /** Colombian peso */
  Cop: 'COP',
  /** Unidad de Valor Real */
  Cou: 'COU',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cuban convertible peso */
  Cuc: 'CUC',
  /** Cuban Peso */
  Cup: 'CUP',
  /** Cape Verde Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djibouti Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian Dinar */
  Dzd: 'DZD',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Fiji Dollar */
  Fjd: 'FJD',
  /** Falkland Islands Pound */
  Fkp: 'FKP',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Lari */
  Gel: 'GEL',
  /** Ghana Cedi */
  Ghs: 'GHS',
  /** Gibraltar Pound */
  Gip: 'GIP',
  /** Dalasi */
  Gmd: 'GMD',
  /** Guinea Franc */
  Gnf: 'GNF',
  /** Quetzal */
  Gtq: 'GTQ',
  /** Guyana Dollar */
  Gyd: 'GYD',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Haitian gourde */
  Htg: 'HTG',
  /** Forint */
  Huf: 'HUF',
  /** Rupiah */
  Idr: 'IDR',
  /** New Israeli Sheqel */
  Ils: 'ILS',
  /** Isle of Man Pound */
  Imp: 'IMP',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Iceland Krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Som */
  Kgs: 'KGS',
  /** Riel */
  Khr: 'KHR',
  /** Comoro Franc */
  Kmf: 'KMF',
  /** North Korean Won */
  Kpw: 'KPW',
  /** Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Cayman Islands Dollar */
  Kyd: 'KYD',
  /** Tenge */
  Kzt: 'KZT',
  /** Kip */
  Lak: 'LAK',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lanka Rupee */
  Lkr: 'LKR',
  /** Liberian Dollar */
  Lrd: 'LRD',
  /** Lesotho loti */
  Lsl: 'LSL',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Denar */
  Mkd: 'MKD',
  /** Kyat */
  Mmk: 'MMK',
  /** Tugrik */
  Mnt: 'MNT',
  /** Pataca */
  Mop: 'MOP',
  /** Ouguiya */
  Mro: 'MRO',
  /** Mauritius Rupee */
  Mur: 'MUR',
  /** Rufiyaa */
  Mvr: 'MVR',
  /** Malawian Kwacha */
  Mwk: 'MWK',
  /** Mexican peso */
  Mxn: 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv: 'MXV',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Naira */
  Ngn: 'NGN',
  /** Cordoba Oro */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Rial Omani */
  Omr: 'OMR',
  /** Balboa */
  Pab: 'PAB',
  /** Nuevo Sol */
  Pen: 'PEN',
  /** Kina */
  Pgk: 'PGK',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistan Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Guarani */
  Pyg: 'PYG',
  /** Qatari Rial */
  Qar: 'QAR',
  /** New Leu */
  Ron: 'RON',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian Ruble */
  Rub: 'RUB',
  /** Rwanda Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Solomon Islands Dollar */
  Sbd: 'SBD',
  /** Seychelles Rupee */
  Scr: 'SCR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore Dollar */
  Sgd: 'SGD',
  /** Saint Helena Pound */
  Shp: 'SHP',
  /** Leone */
  Sll: 'SLL',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Surinam Dollar */
  Srd: 'SRD',
  /** South Sudanese Pound */
  Ssp: 'SSP',
  /** Dobra */
  Std: 'STD',
  /** El Salvador Colon */
  Svc: 'SVC',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Lilangeni */
  Szl: 'SZL',
  /** Baht */
  Thb: 'THB',
  /** Somoni */
  Tjs: 'TJS',
  /** Manat */
  Tmm: 'TMM',
  /** Turkmenistan New Manat */
  Tmt: 'TMT',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Paanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** Tuvalu dollar */
  Tvd: 'TVD',
  /** New Taiwan Dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Hryvnia */
  Uah: 'UAH',
  /** Uganda Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** US Dollar (Next day) */
  Usn: 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi: 'UYI',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Sum */
  Uzs: 'UZS',
  /** Bolivar Fuerte */
  Vef: 'VEF',
  /** Dong */
  Vnd: 'VND',
  /** Vatu */
  Vuv: 'VUV',
  /** Tala */
  Wst: 'WST',
  /** CFA franc BEAC */
  Xaf: 'XAF',
  /** Silver */
  Xag: 'XAG',
  /** Gold */
  Xau: 'XAU',
  /** Bond Markets Units European Composite Unit (EURCO) */
  Xba: 'XBA',
  /** European Monetary Unit (E.M.U.-6) */
  Xbb: 'XBB',
  /** European Unit of Account 9(E.U.A.-9) */
  Xbc: 'XBC',
  /** European Unit of Account 17(E.U.A.-17) */
  Xbd: 'XBD',
  /** East Caribbean Dollar */
  Xcd: 'XCD',
  /** SDR */
  Xdr: 'XDR',
  /** Gold-Franc */
  Xfo: 'XFO',
  /** UIC-Franc */
  Xfu: 'XFU',
  /** CFA Franc BCEAO */
  Xof: 'XOF',
  /** Palladium */
  Xpd: 'XPD',
  /** CFP Franc */
  Xpf: 'XPF',
  /** Platinum */
  Xpt: 'XPT',
  /** Sucre */
  Xsu: 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts: 'XTS',
  /** ADB Unit of Account */
  Xua: 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx: 'XXX',
  /** Yemeni Rial */
  Yer: 'YER',
  /** Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zambian Kwacha */
  Zmw: 'ZMW',
  /** Zimbabwe Dollar A/06 */
  Zwd: 'ZWD',
  /** Zimbabwe dollar A/09 */
  Zwl: 'ZWL',
  /** Zimbabwe dollar A/08 */
  Zwn: 'ZWN'
});


export type AutoRecordGrossAmountCurrency = $Values<typeof AutoRecordGrossAmountCurrencyValues>;

export const InputChannelEnumValues = Object.freeze({
  Bank: 'bank',
  Debitoor: 'debitoor',
  DocumentUpload: 'documentUpload',
  Dropbox: 'dropbox',
  Elster: 'elster',
  ElsterPreview: 'elsterPreview',
  Excel: 'excel',
  GoogleDrive: 'googleDrive',
  GoogleSheets: 'googleSheets',
  InvoicingTool: 'invoicingTool',
  Lexoffice: 'lexoffice',
  Manually: 'manually',
  OneDrive: 'oneDrive',
  Recurring: 'recurring',
  Sevdesk: 'sevdesk',
  Stripe: 'stripe',
  TaxAdvisor: 'taxAdvisor',
  TaxServicesInvoice: 'taxServicesInvoice',
  Unknown: 'unknown'
});


export type InputChannelEnum = $Values<typeof InputChannelEnumValues>;

export type InvoiceType = {|
  ...Node,
  ...{|
    __typename?: 'InvoiceType',
    attachmentFilename?: ?$ElementType<Scalars, 'String'>,
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    currency: $ElementType<Scalars, 'String'>,
    customer?: ?BusinessCustomerType,
    date: $ElementType<Scalars, 'Date'>,
    document?: ?DocumentType,
    downloadUrl?: ?$ElementType<Scalars, 'String'>,
    dueDate?: ?$ElementType<Scalars, 'Date'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoiceNumber: $ElementType<Scalars, 'String'>,
    isServiceOrGoods?: ?SaleType,
    isTaxNumberMissing: $ElementType<Scalars, 'Boolean'>,
    language?: ?Languages,
    lineItems?: ?InvoiceLineItemTypeConnection,
    notes?: ?$ElementType<Scalars, 'String'>,
    paymentAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    paymentMethod?: ?InvoicePaymentMethodType,
    personalNote?: ?$ElementType<Scalars, 'String'>,
    record?: ?RecordType,
    serviceDateFrom?: ?$ElementType<Scalars, 'Date'>,
    serviceDateUntil?: ?$ElementType<Scalars, 'Date'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatExemptionParagraph?: ?VatExemptionParagraph,
    vatRate?: ?$ElementType<Scalars, 'Float'>,
  |}
|};


export type InvoiceTypeLineItemsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type BusinessCustomerType = {|
  ...Node,
  ...{|
    __typename?: 'BusinessCustomerType',
    address: $ElementType<Scalars, 'JSONString'>,
    business: BusinessType,
    businessName?: ?$ElementType<Scalars, 'String'>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    displayName?: ?$ElementType<Scalars, 'String'>,
    email?: ?$ElementType<Scalars, 'String'>,
    firstName?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoices: InvoiceTypeConnection,
    isPrivatePerson: $ElementType<Scalars, 'Boolean'>,
    lastName?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatNumber?: ?$ElementType<Scalars, 'String'>,
  |}
|};


export type BusinessCustomerTypeInvoicesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type InvoiceTypeConnection = {|
  __typename?: 'InvoiceTypeConnection',
  count?: ?$ElementType<Scalars, 'Int'>,
  /** Contains the nodes in this connection. */
  edges: Array<?InvoiceTypeEdge>,
  exists?: ?$ElementType<Scalars, 'Boolean'>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `InvoiceType` and its cursor. */
export type InvoiceTypeEdge = {|
  __typename?: 'InvoiceTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?InvoiceType,
|};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {|
  __typename?: 'PageInfo',
  /** When paginating forwards, the cursor to continue. */
  endCursor?: ?$ElementType<Scalars, 'String'>,
  /** When paginating forwards, are there more items? */
  hasNextPage: $ElementType<Scalars, 'Boolean'>,
  /** When paginating backwards, are there more items? */
  hasPreviousPage: $ElementType<Scalars, 'Boolean'>,
  /** When paginating backwards, the cursor to continue. */
  startCursor?: ?$ElementType<Scalars, 'String'>,
|};

export const SaleTypeValues = Object.freeze({
  Goods: 'goods',
  OtherVatfree: 'other_vatfree',
  Service: 'service',
  VatRefund: 'vat_refund'
});


export type SaleType = $Values<typeof SaleTypeValues>;

export const LanguagesValues = Object.freeze({
  De: 'de',
  En: 'en'
});


export type Languages = $Values<typeof LanguagesValues>;

export type InvoiceLineItemTypeConnection = {|
  __typename?: 'InvoiceLineItemTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?InvoiceLineItemTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `InvoiceLineItemType` and its cursor. */
export type InvoiceLineItemTypeEdge = {|
  __typename?: 'InvoiceLineItemTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?InvoiceLineItemType,
|};

export type InvoiceLineItemType = {|
  ...Node,
  ...{|
    __typename?: 'InvoiceLineItemType',
    createdAt: $ElementType<Scalars, 'DateTime'>,
    description: $ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoice: InvoiceType,
    quantity?: ?$ElementType<Scalars, 'DecimalScalar'>,
    total?: ?$ElementType<Scalars, 'DecimalScalar'>,
    unit?: ?ItemUnit,
    unitPrice?: ?$ElementType<Scalars, 'DecimalScalar'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};

export const ItemUnitValues = Object.freeze({
  Days: 'days',
  Hours: 'hours',
  Items: 'items'
});


export type ItemUnit = $Values<typeof ItemUnitValues>;

export type InvoicePaymentMethodType = {|
  ...Node,
  ...{|
    __typename?: 'InvoicePaymentMethodType',
    accountNumber?: ?$ElementType<Scalars, 'String'>,
    bic?: ?$ElementType<Scalars, 'String'>,
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    email?: ?$ElementType<Scalars, 'String'>,
    iban?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoices: InvoiceTypeConnection,
    isDefault: $ElementType<Scalars, 'Boolean'>,
    name?: ?$ElementType<Scalars, 'String'>,
    paymentMethodType?: ?PaymentMethod,
    text?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};


export type InvoicePaymentMethodTypeInvoicesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export const PaymentMethodValues = Object.freeze({
  BankWithAccountNumber: 'bank_with_account_number',
  BankWithIban: 'bank_with_iban',
  FreeTextForm: 'free_text_form',
  Paypal: 'paypal'
});


export type PaymentMethod = $Values<typeof PaymentMethodValues>;

export const VatExemptionParagraphValues = Object.freeze({
  Paragraph_1: 'paragraph_1',
  Paragraph_10: 'paragraph_10',
  Paragraph_11: 'paragraph_11',
  Paragraph_11a: 'paragraph_11a',
  Paragraph_11b: 'paragraph_11b',
  Paragraph_12: 'paragraph_12',
  Paragraph_13: 'paragraph_13',
  Paragraph_14: 'paragraph_14',
  Paragraph_15: 'paragraph_15',
  Paragraph_15a: 'paragraph_15a',
  Paragraph_15b: 'paragraph_15b',
  Paragraph_15c: 'paragraph_15c',
  Paragraph_16: 'paragraph_16',
  Paragraph_17: 'paragraph_17',
  Paragraph_18: 'paragraph_18',
  Paragraph_18a: 'paragraph_18a',
  Paragraph_2: 'paragraph_2',
  Paragraph_20: 'paragraph_20',
  Paragraph_21: 'paragraph_21',
  Paragraph_22: 'paragraph_22',
  Paragraph_23: 'paragraph_23',
  Paragraph_24: 'paragraph_24',
  Paragraph_25: 'paragraph_25',
  Paragraph_26: 'paragraph_26',
  Paragraph_27: 'paragraph_27',
  Paragraph_28: 'paragraph_28',
  Paragraph_29: 'paragraph_29',
  Paragraph_3: 'paragraph_3',
  Paragraph_4: 'paragraph_4',
  Paragraph_4a: 'paragraph_4a',
  Paragraph_4b: 'paragraph_4b',
  Paragraph_5: 'paragraph_5',
  Paragraph_6: 'paragraph_6',
  Paragraph_7: 'paragraph_7',
  Paragraph_8: 'paragraph_8',
  Paragraph_9: 'paragraph_9'
});


export type VatExemptionParagraph = $Values<typeof VatExemptionParagraphValues>;

export const PartialRecordSourceCategoryEnumValues = Object.freeze({
  Bank: 'bank',
  Imported: 'imported',
  Recurring: 'recurring',
  Uploaded: 'uploaded'
});


export type PartialRecordSourceCategoryEnum = $Values<typeof PartialRecordSourceCategoryEnumValues>;

export type RecurringRecordSettingType = {|
  ...Node,
  ...{|
    __typename?: 'RecurringRecordSettingType',
    createdAt: $ElementType<Scalars, 'DateTime'>,
    derivedAutorecords: AutoRecordTypeConnection,
    derivedRecords: RecordTypeConnection,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    startDate: $ElementType<Scalars, 'Date'>,
    uid?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};


export type RecurringRecordSettingTypeDerivedAutorecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type RecurringRecordSettingTypeDerivedRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export const VatReportingIntervalValues = Object.freeze({
  Monthly: 'monthly',
  Quarterly: 'quarterly',
  Unknown: 'unknown',
  Yearly: 'yearly'
});


export type VatReportingInterval = $Values<typeof VatReportingIntervalValues>;

export type VatReportType = {|
  ...BaseReportInterface,
  ...BaseVatReportInterface,
  ...Node,
  ...ReportPeriodInterface,
  ...VatReportInterface,
  ...{|
    __typename?: 'VatReportType',
    allLines?: ?Array<?VatReportLineType>,
    allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
    autorecordSet: AutoRecordTypeConnection,
    business?: ?BusinessType,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    expensesWithoutAttributionToVatExemptRevenue?: ?RecordTypeConnection,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    importedTotalAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    inputTax?: ?$ElementType<Scalars, 'DecimalScalar'>,
    invoicesWithoutTaxNumber?: ?RecordTypeConnection,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isFirstVatReportWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    isPaid?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    paymentRecord?: ?RecordType,
    paymentReference?: ?$ElementType<Scalars, 'String'>,
    periodStartDate?: ?$ElementType<Scalars, 'Date'>,
    recordSet: RecordTypeConnection,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    reportingInterval?: ?VatReportingInterval,
    reportPeriod: VatReportReportPeriod,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    shouldPayVatInYear?: ?$ElementType<Scalars, 'Boolean'>,
    storedLines: VatReportLineTypeConnection,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
    totalRevenueFromServiceToCustomersInTheEu?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalVatToBePaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
    unpaidRecords?: ?RecordTypeConnection,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatCollected?: ?$ElementType<Scalars, 'DecimalScalar'>,
  |}
|};


export type VatReportTypeAutorecordSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type VatReportTypeExpensesWithoutAttributionToVatExemptRevenueArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type VatReportTypeInvoicesWithoutTaxNumberArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type VatReportTypeRecordSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type VatReportTypeStoredLinesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type VatReportTypeUnpaidRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type ReportPeriodInterface = {|
  allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
  periodStartDate?: ?$ElementType<Scalars, 'Date'>,
  reportingInterval?: ?VatReportingInterval,
  submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
  submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
|};

export const ReportSubmitUrgencyLevelValues = Object.freeze({
  InputNeeded: 'input_needed',
  Open: 'open',
  Overdue: 'overdue',
  PreparedByTaxAdvisor: 'prepared_by_tax_advisor',
  Upcoming: 'upcoming'
});


export type ReportSubmitUrgencyLevel = $Values<typeof ReportSubmitUrgencyLevelValues>;

export type VatReportInterface = {|
  allLines?: ?Array<?VatReportLineType>,
  business?: ?BusinessType,
  paymentReference?: ?$ElementType<Scalars, 'String'>,
  shouldPayVatInYear?: ?$ElementType<Scalars, 'Boolean'>,
  totalVatToBePaid?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};

export type VatReportLineType = {|
  ...Node,
  ...{|
    __typename?: 'VatReportLineType',
    bookingCategory?: ?VatReportBookingCategory,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    lineCategory?: ?VatReportLineCategory,
    netAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    recordIds?: ?Array<?$ElementType<Scalars, 'String'>>,
    taxAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatReport: VatReportType,
  |}
|};

export const VatReportBookingCategoryValues = Object.freeze({
  InputTaxFromGoodsBoughtEuSupplier: 'input_tax_from_goods_bought_eu_supplier',
  InputTaxServicesFromEuSupplier: 'input_tax_services_from_eu_supplier',
  LocalInputTax: 'local_input_tax',
  SalesOtherVatRate: 'sales_other_vat_rate',
  SalesWith_19Vat: 'sales_with_19_vat',
  SalesWith_7Vat: 'sales_with_7_vat',
  SmallBusinessOwnerIncome: 'small_business_owner_income',
  SmallBusinessOwnerTaxableGoodsBoughtFromEuSupplier_19Vat: 'small_business_owner_taxable_goods_bought_from_eu_supplier_19_vat',
  SmallBusinessOwnerTaxableGoodsBoughtFromEuSupplier_7Vat: 'small_business_owner_taxable_goods_bought_from_eu_supplier_7_vat',
  SmallBusinessOwnerTaxableGoodsBoughtFromEuSupplierOtherVat: 'small_business_owner_taxable_goods_bought_from_eu_supplier_other_vat',
  SmallBusinessOwnerTaxableServiceFromEuSupplier: 'small_business_owner_taxable_service_from_eu_supplier',
  TaxFreeRentalAndLeasingSales: 'tax_free_rental_and_leasing_sales',
  TaxFreeSaleEuGoods: 'tax_free_sale_eu_goods',
  TaxFreeSaleEuService: 'tax_free_sale_eu_service',
  TaxFreeSaleNonEuGoods: 'tax_free_sale_non_eu_goods',
  TaxFreeSaleNonEuService: 'tax_free_sale_non_eu_service',
  TaxFreeSales: 'tax_free_sales',
  TaxFreeSalesP7OrUnder: 'tax_free_sales_p7_or_under',
  TaxableGoodsBoughtFromEuSupplier_19Vat: 'taxable_goods_bought_from_eu_supplier_19_vat',
  TaxableGoodsBoughtFromEuSupplier_7Vat: 'taxable_goods_bought_from_eu_supplier_7_vat',
  TaxableGoodsBoughtFromEuSupplierOtherVat: 'taxable_goods_bought_from_eu_supplier_other_vat',
  TaxableServiceFromEuSupplier: 'taxable_service_from_eu_supplier'
});


export type VatReportBookingCategory = $Values<typeof VatReportBookingCategoryValues>;

export const VatReportLineCategoryValues = Object.freeze({
  Expense: 'expense',
  Income: 'income'
});


export type VatReportLineCategory = $Values<typeof VatReportLineCategoryValues>;

export const VatReportReportPeriodValues = Object.freeze({
  /** Monthly */
  Monthly: 'MONTHLY',
  /** Quarterly */
  Quarterly: 'QUARTERLY',
  /** Unknown */
  Unknown: 'UNKNOWN',
  /** Yearly */
  Yearly: 'YEARLY'
});


export type VatReportReportPeriod = $Values<typeof VatReportReportPeriodValues>;

export type VatReportLineTypeConnection = {|
  __typename?: 'VatReportLineTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?VatReportLineTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `VatReportLineType` and its cursor. */
export type VatReportLineTypeEdge = {|
  __typename?: 'VatReportLineTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?VatReportLineType,
|};

export type ZmReportType = {|
  ...BaseReportInterface,
  ...Node,
  ...ReportPeriodInterface,
  ...{|
    __typename?: 'ZmReportType',
    allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
    autorecordSet: AutoRecordTypeConnection,
    business: BusinessType,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    lines?: ?Array<?ZmReportDataLine>,
    periodStartDate?: ?$ElementType<Scalars, 'Date'>,
    recordSet: RecordTypeConnection,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    reportingInterval?: ?VatReportingInterval,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
    totalRevenue?: ?$ElementType<Scalars, 'DecimalScalar'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};


export type ZmReportTypeAutorecordSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type ZmReportTypeRecordSetArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type ZmReportDataLine = {|
  __typename?: 'ZmReportDataLine',
  amount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  recordIds?: ?Array<?$ElementType<Scalars, 'String'>>,
  saleType?: ?$ElementType<Scalars, 'String'>,
  vatNumber?: ?$ElementType<Scalars, 'String'>,
|};

export const BankProviderCategorizationValues = Object.freeze({
  Business: 'business',
  Personal: 'personal'
});


export type BankProviderCategorization = $Values<typeof BankProviderCategorizationValues>;


export type BankAttemptType = {|
  __typename?: 'BankAttemptType',
  failAt?: ?$ElementType<Scalars, 'DateTimeStringScalar'>,
  failErrorClass?: ?$ElementType<Scalars, 'String'>,
  failMessage?: ?$ElementType<Scalars, 'String'>,
  fromDate?: ?$ElementType<Scalars, 'DateStringScalar'>,
  id: $ElementType<Scalars, 'ID'>,
  successAt?: ?$ElementType<Scalars, 'DateTimeStringScalar'>,
|};


export type BankProviderType = {|
  __typename?: 'BankProviderType',
  connectable?: ?$ElementType<Scalars, 'Boolean'>,
  id: $ElementType<Scalars, 'ID'>,
  logoUrl?: ?$ElementType<Scalars, 'String'>,
  name?: ?$ElementType<Scalars, 'String'>,
|};

export const BankConnectionStatusValues = Object.freeze({
  Active: 'active',
  Disabled: 'disabled',
  Inactive: 'inactive'
});


export type BankConnectionStatus = $Values<typeof BankConnectionStatusValues>;

export type TaxAdvisorType = {|
  ...Node,
  ...{|
    __typename?: 'TaxAdvisorType',
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    intercomId: $ElementType<Scalars, 'String'>,
    languagesSettings: TaxAdvisorLanguageTypeConnection,
    name: $ElementType<Scalars, 'String'>,
    pictureUrl?: ?$ElementType<Scalars, 'String'>,
    platformFees: TaxServiceBillingTypeConnection,
    taxAdvisory: TaxAdvisoryType,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    user: UserType,
  |}
|};


export type TaxAdvisorTypeLanguagesSettingsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  language?: ?TaxAdvisorLanguageSettingsLanguage,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type TaxAdvisorTypePlatformFeesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export const TaxAdvisorLanguageSettingsLanguageValues = Object.freeze({
  /** German */
  De: 'DE',
  /** English */
  En: 'EN'
});


export type TaxAdvisorLanguageSettingsLanguage = $Values<typeof TaxAdvisorLanguageSettingsLanguageValues>;

export type TaxAdvisorLanguageTypeConnection = {|
  __typename?: 'TaxAdvisorLanguageTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?TaxAdvisorLanguageTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `TaxAdvisorLanguageType` and its cursor. */
export type TaxAdvisorLanguageTypeEdge = {|
  __typename?: 'TaxAdvisorLanguageTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?TaxAdvisorLanguageType,
|};

export type TaxAdvisorLanguageType = {|
  ...Node,
  ...{|
    __typename?: 'TaxAdvisorLanguageType',
    bio: $ElementType<Scalars, 'String'>,
    calendlyLongCallUrl?: ?$ElementType<Scalars, 'String'>,
    calendlyUrl: $ElementType<Scalars, 'String'>,
    capacityWeight: $ElementType<Scalars, 'Int'>,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    language: TaxAdvisorLanguageSettingsLanguage,
    taxAdvisor: TaxAdvisorType,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    videoUrl?: ?$ElementType<Scalars, 'String'>,
  |}
|};

export type TaxServiceBillingTypeConnection = {|
  __typename?: 'TaxServiceBillingTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?TaxServiceBillingTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `TaxServiceBillingType` and its cursor. */
export type TaxServiceBillingTypeEdge = {|
  __typename?: 'TaxServiceBillingTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?TaxServiceBillingType,
|};

export type TaxServiceBillingType = {|
  ...Node,
  ...{|
    __typename?: 'TaxServiceBillingType',
    business?: ?BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    customDescription?: ?$ElementType<Scalars, 'String'>,
    hasFailedAttempt: $ElementType<Scalars, 'Boolean'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoiceNumber?: ?$ElementType<Scalars, 'String'>,
    paymentDate?: ?$ElementType<Scalars, 'Date'>,
    platformFeeNet: $ElementType<Scalars, 'DecimalScalar'>,
    platformFeeNetCurrency: TaxServiceBillingPlatformFeeNetCurrency,
    platformFeeTotal: $ElementType<Scalars, 'DecimalScalar'>,
    platformFeeTotalCurrency: TaxServiceBillingPlatformFeeTotalCurrency,
    serviceDate?: ?$ElementType<Scalars, 'Date'>,
    serviceNameHumanized?: ?$ElementType<Scalars, 'String'>,
    serviceType?: ?TaxServiceType,
    state?: ?ServiceFeeState,
    taxAdvisor?: ?TaxAdvisorType,
    taxAdvisory: TaxAdvisoryType,
    totalNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
    totalNetAmountCurrency: TaxServiceBillingTotalNetAmountCurrency,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};


export type TaxServiceBillingTypeServiceNameHumanizedArgs = {|
  isCapitalized?: ?$ElementType<Scalars, 'Boolean'>,
|};

export const TaxServiceBillingPlatformFeeNetCurrencyValues = Object.freeze({
  /** UAE Dirham */
  Aed: 'AED',
  /** Afghani */
  Afn: 'AFN',
  /** Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Netherlands Antillian Guilder */
  Ang: 'ANG',
  /** Kwanza */
  Aoa: 'AOA',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Aruban Guilder */
  Awg: 'AWG',
  /** Azerbaijanian Manat */
  Azn: 'AZN',
  /** Convertible Marks */
  Bam: 'BAM',
  /** Barbados Dollar */
  Bbd: 'BBD',
  /** Taka */
  Bdt: 'BDT',
  /** Bulgarian Lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundi Franc */
  Bif: 'BIF',
  /** Bermudian Dollar (customarily known as Bermuda Dollar) */
  Bmd: 'BMD',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Boliviano */
  Bob: 'BOB',
  /** Mvdol */
  Bov: 'BOV',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Bahamian Dollar */
  Bsd: 'BSD',
  /** Bhutanese ngultrum */
  Btn: 'BTN',
  /** Pula */
  Bwp: 'BWP',
  /** Belarussian Ruble */
  Byn: 'BYN',
  /** Belarussian Ruble */
  Byr: 'BYR',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese franc */
  Cdf: 'CDF',
  /** WIR Euro */
  Che: 'CHE',
  /** Swiss Franc */
  Chf: 'CHF',
  /** WIR Franc */
  Chw: 'CHW',
  /** Unidad de Fomento */
  Clf: 'CLF',
  /** Chilean peso */
  Clp: 'CLP',
  /** Yuan Renminbi */
  Cny: 'CNY',
  /** Colombian peso */
  Cop: 'COP',
  /** Unidad de Valor Real */
  Cou: 'COU',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cuban convertible peso */
  Cuc: 'CUC',
  /** Cuban Peso */
  Cup: 'CUP',
  /** Cape Verde Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djibouti Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian Dinar */
  Dzd: 'DZD',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Fiji Dollar */
  Fjd: 'FJD',
  /** Falkland Islands Pound */
  Fkp: 'FKP',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Lari */
  Gel: 'GEL',
  /** Ghana Cedi */
  Ghs: 'GHS',
  /** Gibraltar Pound */
  Gip: 'GIP',
  /** Dalasi */
  Gmd: 'GMD',
  /** Guinea Franc */
  Gnf: 'GNF',
  /** Quetzal */
  Gtq: 'GTQ',
  /** Guyana Dollar */
  Gyd: 'GYD',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Haitian gourde */
  Htg: 'HTG',
  /** Forint */
  Huf: 'HUF',
  /** Rupiah */
  Idr: 'IDR',
  /** New Israeli Sheqel */
  Ils: 'ILS',
  /** Isle of Man Pound */
  Imp: 'IMP',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Iceland Krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Som */
  Kgs: 'KGS',
  /** Riel */
  Khr: 'KHR',
  /** Comoro Franc */
  Kmf: 'KMF',
  /** North Korean Won */
  Kpw: 'KPW',
  /** Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Cayman Islands Dollar */
  Kyd: 'KYD',
  /** Tenge */
  Kzt: 'KZT',
  /** Kip */
  Lak: 'LAK',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lanka Rupee */
  Lkr: 'LKR',
  /** Liberian Dollar */
  Lrd: 'LRD',
  /** Lesotho loti */
  Lsl: 'LSL',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Denar */
  Mkd: 'MKD',
  /** Kyat */
  Mmk: 'MMK',
  /** Tugrik */
  Mnt: 'MNT',
  /** Pataca */
  Mop: 'MOP',
  /** Ouguiya */
  Mro: 'MRO',
  /** Mauritius Rupee */
  Mur: 'MUR',
  /** Rufiyaa */
  Mvr: 'MVR',
  /** Malawian Kwacha */
  Mwk: 'MWK',
  /** Mexican peso */
  Mxn: 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv: 'MXV',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Naira */
  Ngn: 'NGN',
  /** Cordoba Oro */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Rial Omani */
  Omr: 'OMR',
  /** Balboa */
  Pab: 'PAB',
  /** Nuevo Sol */
  Pen: 'PEN',
  /** Kina */
  Pgk: 'PGK',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistan Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Guarani */
  Pyg: 'PYG',
  /** Qatari Rial */
  Qar: 'QAR',
  /** New Leu */
  Ron: 'RON',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian Ruble */
  Rub: 'RUB',
  /** Rwanda Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Solomon Islands Dollar */
  Sbd: 'SBD',
  /** Seychelles Rupee */
  Scr: 'SCR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore Dollar */
  Sgd: 'SGD',
  /** Saint Helena Pound */
  Shp: 'SHP',
  /** Leone */
  Sll: 'SLL',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Surinam Dollar */
  Srd: 'SRD',
  /** South Sudanese Pound */
  Ssp: 'SSP',
  /** Dobra */
  Std: 'STD',
  /** El Salvador Colon */
  Svc: 'SVC',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Lilangeni */
  Szl: 'SZL',
  /** Baht */
  Thb: 'THB',
  /** Somoni */
  Tjs: 'TJS',
  /** Manat */
  Tmm: 'TMM',
  /** Turkmenistan New Manat */
  Tmt: 'TMT',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Paanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** Tuvalu dollar */
  Tvd: 'TVD',
  /** New Taiwan Dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Hryvnia */
  Uah: 'UAH',
  /** Uganda Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** US Dollar (Next day) */
  Usn: 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi: 'UYI',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Sum */
  Uzs: 'UZS',
  /** Bolivar Fuerte */
  Vef: 'VEF',
  /** Dong */
  Vnd: 'VND',
  /** Vatu */
  Vuv: 'VUV',
  /** Tala */
  Wst: 'WST',
  /** CFA franc BEAC */
  Xaf: 'XAF',
  /** Silver */
  Xag: 'XAG',
  /** Gold */
  Xau: 'XAU',
  /** Bond Markets Units European Composite Unit (EURCO) */
  Xba: 'XBA',
  /** European Monetary Unit (E.M.U.-6) */
  Xbb: 'XBB',
  /** European Unit of Account 9(E.U.A.-9) */
  Xbc: 'XBC',
  /** European Unit of Account 17(E.U.A.-17) */
  Xbd: 'XBD',
  /** East Caribbean Dollar */
  Xcd: 'XCD',
  /** SDR */
  Xdr: 'XDR',
  /** Gold-Franc */
  Xfo: 'XFO',
  /** UIC-Franc */
  Xfu: 'XFU',
  /** CFA Franc BCEAO */
  Xof: 'XOF',
  /** Palladium */
  Xpd: 'XPD',
  /** CFP Franc */
  Xpf: 'XPF',
  /** Platinum */
  Xpt: 'XPT',
  /** Sucre */
  Xsu: 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts: 'XTS',
  /** ADB Unit of Account */
  Xua: 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx: 'XXX',
  /** Yemeni Rial */
  Yer: 'YER',
  /** Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zambian Kwacha */
  Zmw: 'ZMW',
  /** Zimbabwe Dollar A/06 */
  Zwd: 'ZWD',
  /** Zimbabwe dollar A/09 */
  Zwl: 'ZWL',
  /** Zimbabwe dollar A/08 */
  Zwn: 'ZWN'
});


export type TaxServiceBillingPlatformFeeNetCurrency = $Values<typeof TaxServiceBillingPlatformFeeNetCurrencyValues>;

export const TaxServiceBillingPlatformFeeTotalCurrencyValues = Object.freeze({
  /** UAE Dirham */
  Aed: 'AED',
  /** Afghani */
  Afn: 'AFN',
  /** Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Netherlands Antillian Guilder */
  Ang: 'ANG',
  /** Kwanza */
  Aoa: 'AOA',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Aruban Guilder */
  Awg: 'AWG',
  /** Azerbaijanian Manat */
  Azn: 'AZN',
  /** Convertible Marks */
  Bam: 'BAM',
  /** Barbados Dollar */
  Bbd: 'BBD',
  /** Taka */
  Bdt: 'BDT',
  /** Bulgarian Lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundi Franc */
  Bif: 'BIF',
  /** Bermudian Dollar (customarily known as Bermuda Dollar) */
  Bmd: 'BMD',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Boliviano */
  Bob: 'BOB',
  /** Mvdol */
  Bov: 'BOV',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Bahamian Dollar */
  Bsd: 'BSD',
  /** Bhutanese ngultrum */
  Btn: 'BTN',
  /** Pula */
  Bwp: 'BWP',
  /** Belarussian Ruble */
  Byn: 'BYN',
  /** Belarussian Ruble */
  Byr: 'BYR',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese franc */
  Cdf: 'CDF',
  /** WIR Euro */
  Che: 'CHE',
  /** Swiss Franc */
  Chf: 'CHF',
  /** WIR Franc */
  Chw: 'CHW',
  /** Unidad de Fomento */
  Clf: 'CLF',
  /** Chilean peso */
  Clp: 'CLP',
  /** Yuan Renminbi */
  Cny: 'CNY',
  /** Colombian peso */
  Cop: 'COP',
  /** Unidad de Valor Real */
  Cou: 'COU',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cuban convertible peso */
  Cuc: 'CUC',
  /** Cuban Peso */
  Cup: 'CUP',
  /** Cape Verde Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djibouti Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian Dinar */
  Dzd: 'DZD',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Fiji Dollar */
  Fjd: 'FJD',
  /** Falkland Islands Pound */
  Fkp: 'FKP',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Lari */
  Gel: 'GEL',
  /** Ghana Cedi */
  Ghs: 'GHS',
  /** Gibraltar Pound */
  Gip: 'GIP',
  /** Dalasi */
  Gmd: 'GMD',
  /** Guinea Franc */
  Gnf: 'GNF',
  /** Quetzal */
  Gtq: 'GTQ',
  /** Guyana Dollar */
  Gyd: 'GYD',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Haitian gourde */
  Htg: 'HTG',
  /** Forint */
  Huf: 'HUF',
  /** Rupiah */
  Idr: 'IDR',
  /** New Israeli Sheqel */
  Ils: 'ILS',
  /** Isle of Man Pound */
  Imp: 'IMP',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Iceland Krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Som */
  Kgs: 'KGS',
  /** Riel */
  Khr: 'KHR',
  /** Comoro Franc */
  Kmf: 'KMF',
  /** North Korean Won */
  Kpw: 'KPW',
  /** Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Cayman Islands Dollar */
  Kyd: 'KYD',
  /** Tenge */
  Kzt: 'KZT',
  /** Kip */
  Lak: 'LAK',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lanka Rupee */
  Lkr: 'LKR',
  /** Liberian Dollar */
  Lrd: 'LRD',
  /** Lesotho loti */
  Lsl: 'LSL',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Denar */
  Mkd: 'MKD',
  /** Kyat */
  Mmk: 'MMK',
  /** Tugrik */
  Mnt: 'MNT',
  /** Pataca */
  Mop: 'MOP',
  /** Ouguiya */
  Mro: 'MRO',
  /** Mauritius Rupee */
  Mur: 'MUR',
  /** Rufiyaa */
  Mvr: 'MVR',
  /** Malawian Kwacha */
  Mwk: 'MWK',
  /** Mexican peso */
  Mxn: 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv: 'MXV',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Naira */
  Ngn: 'NGN',
  /** Cordoba Oro */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Rial Omani */
  Omr: 'OMR',
  /** Balboa */
  Pab: 'PAB',
  /** Nuevo Sol */
  Pen: 'PEN',
  /** Kina */
  Pgk: 'PGK',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistan Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Guarani */
  Pyg: 'PYG',
  /** Qatari Rial */
  Qar: 'QAR',
  /** New Leu */
  Ron: 'RON',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian Ruble */
  Rub: 'RUB',
  /** Rwanda Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Solomon Islands Dollar */
  Sbd: 'SBD',
  /** Seychelles Rupee */
  Scr: 'SCR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore Dollar */
  Sgd: 'SGD',
  /** Saint Helena Pound */
  Shp: 'SHP',
  /** Leone */
  Sll: 'SLL',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Surinam Dollar */
  Srd: 'SRD',
  /** South Sudanese Pound */
  Ssp: 'SSP',
  /** Dobra */
  Std: 'STD',
  /** El Salvador Colon */
  Svc: 'SVC',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Lilangeni */
  Szl: 'SZL',
  /** Baht */
  Thb: 'THB',
  /** Somoni */
  Tjs: 'TJS',
  /** Manat */
  Tmm: 'TMM',
  /** Turkmenistan New Manat */
  Tmt: 'TMT',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Paanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** Tuvalu dollar */
  Tvd: 'TVD',
  /** New Taiwan Dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Hryvnia */
  Uah: 'UAH',
  /** Uganda Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** US Dollar (Next day) */
  Usn: 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi: 'UYI',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Sum */
  Uzs: 'UZS',
  /** Bolivar Fuerte */
  Vef: 'VEF',
  /** Dong */
  Vnd: 'VND',
  /** Vatu */
  Vuv: 'VUV',
  /** Tala */
  Wst: 'WST',
  /** CFA franc BEAC */
  Xaf: 'XAF',
  /** Silver */
  Xag: 'XAG',
  /** Gold */
  Xau: 'XAU',
  /** Bond Markets Units European Composite Unit (EURCO) */
  Xba: 'XBA',
  /** European Monetary Unit (E.M.U.-6) */
  Xbb: 'XBB',
  /** European Unit of Account 9(E.U.A.-9) */
  Xbc: 'XBC',
  /** European Unit of Account 17(E.U.A.-17) */
  Xbd: 'XBD',
  /** East Caribbean Dollar */
  Xcd: 'XCD',
  /** SDR */
  Xdr: 'XDR',
  /** Gold-Franc */
  Xfo: 'XFO',
  /** UIC-Franc */
  Xfu: 'XFU',
  /** CFA Franc BCEAO */
  Xof: 'XOF',
  /** Palladium */
  Xpd: 'XPD',
  /** CFP Franc */
  Xpf: 'XPF',
  /** Platinum */
  Xpt: 'XPT',
  /** Sucre */
  Xsu: 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts: 'XTS',
  /** ADB Unit of Account */
  Xua: 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx: 'XXX',
  /** Yemeni Rial */
  Yer: 'YER',
  /** Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zambian Kwacha */
  Zmw: 'ZMW',
  /** Zimbabwe Dollar A/06 */
  Zwd: 'ZWD',
  /** Zimbabwe dollar A/09 */
  Zwl: 'ZWL',
  /** Zimbabwe dollar A/08 */
  Zwn: 'ZWN'
});


export type TaxServiceBillingPlatformFeeTotalCurrency = $Values<typeof TaxServiceBillingPlatformFeeTotalCurrencyValues>;

export const TaxServiceTypeValues = Object.freeze({
  AboutServices: 'about_services',
  Bwa: 'bwa',
  Custom: 'custom',
  GeneralCall: 'general_call',
  GeneralLongCall: 'general_long_call',
  GeneralText: 'general_text',
  IncomeTaxReturnPreparation: 'income_tax_return_preparation',
  ReviewAnnualTaxReports: 'review_annual_tax_reports',
  ReviewRegistrationForm: 'review_registration_form',
  TaxOfficeMessage: 'tax_office_message'
});


export type TaxServiceType = $Values<typeof TaxServiceTypeValues>;

export const ServiceFeeStateValues = Object.freeze({
  Cancelled: 'cancelled',
  ChargeFailed: 'charge_failed',
  Paid: 'paid',
  Pending: 'pending',
  Processing: 'processing'
});


export type ServiceFeeState = $Values<typeof ServiceFeeStateValues>;

export type TaxAdvisoryType = {|
  ...Node,
  ...{|
    __typename?: 'TaxAdvisoryType',
    advisoryMembers: TaxAdvisorTypeConnection,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    currentInvoiceNumber: $ElementType<Scalars, 'Int'>,
    emailToSendInvoices?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    name: $ElementType<Scalars, 'String'>,
    platformFees: TaxServiceBillingTypeConnection,
    stripeAccountId?: ?$ElementType<Scalars, 'String'>,
    termsAndConditionsUrl?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};


export type TaxAdvisoryTypeAdvisoryMembersArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type TaxAdvisoryTypePlatformFeesArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type TaxAdvisorTypeConnection = {|
  __typename?: 'TaxAdvisorTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?TaxAdvisorTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `TaxAdvisorType` and its cursor. */
export type TaxAdvisorTypeEdge = {|
  __typename?: 'TaxAdvisorTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?TaxAdvisorType,
|};

export const TaxServiceBillingTotalNetAmountCurrencyValues = Object.freeze({
  /** UAE Dirham */
  Aed: 'AED',
  /** Afghani */
  Afn: 'AFN',
  /** Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Netherlands Antillian Guilder */
  Ang: 'ANG',
  /** Kwanza */
  Aoa: 'AOA',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Aruban Guilder */
  Awg: 'AWG',
  /** Azerbaijanian Manat */
  Azn: 'AZN',
  /** Convertible Marks */
  Bam: 'BAM',
  /** Barbados Dollar */
  Bbd: 'BBD',
  /** Taka */
  Bdt: 'BDT',
  /** Bulgarian Lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundi Franc */
  Bif: 'BIF',
  /** Bermudian Dollar (customarily known as Bermuda Dollar) */
  Bmd: 'BMD',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Boliviano */
  Bob: 'BOB',
  /** Mvdol */
  Bov: 'BOV',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Bahamian Dollar */
  Bsd: 'BSD',
  /** Bhutanese ngultrum */
  Btn: 'BTN',
  /** Pula */
  Bwp: 'BWP',
  /** Belarussian Ruble */
  Byn: 'BYN',
  /** Belarussian Ruble */
  Byr: 'BYR',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese franc */
  Cdf: 'CDF',
  /** WIR Euro */
  Che: 'CHE',
  /** Swiss Franc */
  Chf: 'CHF',
  /** WIR Franc */
  Chw: 'CHW',
  /** Unidad de Fomento */
  Clf: 'CLF',
  /** Chilean peso */
  Clp: 'CLP',
  /** Yuan Renminbi */
  Cny: 'CNY',
  /** Colombian peso */
  Cop: 'COP',
  /** Unidad de Valor Real */
  Cou: 'COU',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cuban convertible peso */
  Cuc: 'CUC',
  /** Cuban Peso */
  Cup: 'CUP',
  /** Cape Verde Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djibouti Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian Dinar */
  Dzd: 'DZD',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Fiji Dollar */
  Fjd: 'FJD',
  /** Falkland Islands Pound */
  Fkp: 'FKP',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Lari */
  Gel: 'GEL',
  /** Ghana Cedi */
  Ghs: 'GHS',
  /** Gibraltar Pound */
  Gip: 'GIP',
  /** Dalasi */
  Gmd: 'GMD',
  /** Guinea Franc */
  Gnf: 'GNF',
  /** Quetzal */
  Gtq: 'GTQ',
  /** Guyana Dollar */
  Gyd: 'GYD',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Haitian gourde */
  Htg: 'HTG',
  /** Forint */
  Huf: 'HUF',
  /** Rupiah */
  Idr: 'IDR',
  /** New Israeli Sheqel */
  Ils: 'ILS',
  /** Isle of Man Pound */
  Imp: 'IMP',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Iceland Krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Som */
  Kgs: 'KGS',
  /** Riel */
  Khr: 'KHR',
  /** Comoro Franc */
  Kmf: 'KMF',
  /** North Korean Won */
  Kpw: 'KPW',
  /** Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Cayman Islands Dollar */
  Kyd: 'KYD',
  /** Tenge */
  Kzt: 'KZT',
  /** Kip */
  Lak: 'LAK',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lanka Rupee */
  Lkr: 'LKR',
  /** Liberian Dollar */
  Lrd: 'LRD',
  /** Lesotho loti */
  Lsl: 'LSL',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Denar */
  Mkd: 'MKD',
  /** Kyat */
  Mmk: 'MMK',
  /** Tugrik */
  Mnt: 'MNT',
  /** Pataca */
  Mop: 'MOP',
  /** Ouguiya */
  Mro: 'MRO',
  /** Mauritius Rupee */
  Mur: 'MUR',
  /** Rufiyaa */
  Mvr: 'MVR',
  /** Malawian Kwacha */
  Mwk: 'MWK',
  /** Mexican peso */
  Mxn: 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv: 'MXV',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Naira */
  Ngn: 'NGN',
  /** Cordoba Oro */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Rial Omani */
  Omr: 'OMR',
  /** Balboa */
  Pab: 'PAB',
  /** Nuevo Sol */
  Pen: 'PEN',
  /** Kina */
  Pgk: 'PGK',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistan Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Guarani */
  Pyg: 'PYG',
  /** Qatari Rial */
  Qar: 'QAR',
  /** New Leu */
  Ron: 'RON',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian Ruble */
  Rub: 'RUB',
  /** Rwanda Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Solomon Islands Dollar */
  Sbd: 'SBD',
  /** Seychelles Rupee */
  Scr: 'SCR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore Dollar */
  Sgd: 'SGD',
  /** Saint Helena Pound */
  Shp: 'SHP',
  /** Leone */
  Sll: 'SLL',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Surinam Dollar */
  Srd: 'SRD',
  /** South Sudanese Pound */
  Ssp: 'SSP',
  /** Dobra */
  Std: 'STD',
  /** El Salvador Colon */
  Svc: 'SVC',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Lilangeni */
  Szl: 'SZL',
  /** Baht */
  Thb: 'THB',
  /** Somoni */
  Tjs: 'TJS',
  /** Manat */
  Tmm: 'TMM',
  /** Turkmenistan New Manat */
  Tmt: 'TMT',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Paanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** Tuvalu dollar */
  Tvd: 'TVD',
  /** New Taiwan Dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Hryvnia */
  Uah: 'UAH',
  /** Uganda Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** US Dollar (Next day) */
  Usn: 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi: 'UYI',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Sum */
  Uzs: 'UZS',
  /** Bolivar Fuerte */
  Vef: 'VEF',
  /** Dong */
  Vnd: 'VND',
  /** Vatu */
  Vuv: 'VUV',
  /** Tala */
  Wst: 'WST',
  /** CFA franc BEAC */
  Xaf: 'XAF',
  /** Silver */
  Xag: 'XAG',
  /** Gold */
  Xau: 'XAU',
  /** Bond Markets Units European Composite Unit (EURCO) */
  Xba: 'XBA',
  /** European Monetary Unit (E.M.U.-6) */
  Xbb: 'XBB',
  /** European Unit of Account 9(E.U.A.-9) */
  Xbc: 'XBC',
  /** European Unit of Account 17(E.U.A.-17) */
  Xbd: 'XBD',
  /** East Caribbean Dollar */
  Xcd: 'XCD',
  /** SDR */
  Xdr: 'XDR',
  /** Gold-Franc */
  Xfo: 'XFO',
  /** UIC-Franc */
  Xfu: 'XFU',
  /** CFA Franc BCEAO */
  Xof: 'XOF',
  /** Palladium */
  Xpd: 'XPD',
  /** CFP Franc */
  Xpf: 'XPF',
  /** Platinum */
  Xpt: 'XPT',
  /** Sucre */
  Xsu: 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts: 'XTS',
  /** ADB Unit of Account */
  Xua: 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx: 'XXX',
  /** Yemeni Rial */
  Yer: 'YER',
  /** Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zambian Kwacha */
  Zmw: 'ZMW',
  /** Zimbabwe Dollar A/06 */
  Zwd: 'ZWD',
  /** Zimbabwe dollar A/09 */
  Zwl: 'ZWL',
  /** Zimbabwe dollar A/08 */
  Zwn: 'ZWN'
});


export type TaxServiceBillingTotalNetAmountCurrency = $Values<typeof TaxServiceBillingTotalNetAmountCurrencyValues>;

export type UserType = {|
  ...Node,
  ...{|
    __typename?: 'UserType',
    business?: ?BusinessType,
    dateJoined: $ElementType<Scalars, 'DateTime'>,
    email: $ElementType<Scalars, 'String'>,
    firstName: $ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    intercomUserId?: ?$ElementType<Scalars, 'String'>,
    /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: $ElementType<Scalars, 'Boolean'>,
    /** Designates whether the user can log into this admin site. */
  isStaff: $ElementType<Scalars, 'Boolean'>,
    /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: $ElementType<Scalars, 'Boolean'>,
    lastLogin?: ?$ElementType<Scalars, 'DateTime'>,
    lastName: $ElementType<Scalars, 'String'>,
    password: $ElementType<Scalars, 'String'>,
    pictureUrl?: ?$ElementType<Scalars, 'String'>,
    taxAdvisors: TaxAdvisorTypeConnection,
    /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: $ElementType<Scalars, 'String'>,
    userSettings?: ?UserSettingsType,
  |}
|};


export type UserTypeTaxAdvisorsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export type UserSettingsType = {|
  ...Node,
  ...{|
    __typename?: 'UserSettingsType',
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    languageCode: $ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    user?: ?UserType,
  |}
|};

export type BusinessPerformanceType = {|
  __typename?: 'BusinessPerformanceType',
  advanceVatReports?: ?Array<?VatReportType>,
  annualVatReport?: ?AnnualVatReportType,
  autorecords?: ?AutoRecordTypeConnection,
  incomeTaxReport?: ?IncomeTaxReportType,
  pnlReport?: ?PnlReportType,
  year: $ElementType<Scalars, 'Int'>,
|};


export type BusinessPerformanceTypeAutorecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  date_Gte?: ?$ElementType<Scalars, 'Date'>,
  date_Lte?: ?$ElementType<Scalars, 'Date'>,
  dateYear?: ?$ElementType<Scalars, 'Int'>,
  excludeVatPayments?: ?$ElementType<Scalars, 'Boolean'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  idIn?: ?$ElementType<Scalars, 'String'>,
  isPendingApproval?: ?$ElementType<Scalars, 'Boolean'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  paymentDateOrDateYearLte?: ?$ElementType<Scalars, 'Int'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  recommendedRecordsForPendingAutoRecord?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recordType_In?: ?Array<?$ElementType<Scalars, 'String'>>,
  recurringSettingSource_Isnull?: ?$ElementType<Scalars, 'Boolean'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};

export type PnlReportType = {|
  ...BaseReportInterface,
  ...Node,
  ...ReportPeriodInterface,
  ...{|
    __typename?: 'PNLReportType',
    allowSubmission?: ?$ElementType<Scalars, 'Boolean'>,
    business: BusinessType,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    expensesSummary?: ?ExpenseSummaryType,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    incomeSummary?: ?IncomeSummaryType,
    invoicesWithoutTaxNumber?: ?RecordTypeConnection,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isPayingVatInYear?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    periodStartDate?: ?$ElementType<Scalars, 'Date'>,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    reportedProfitOrLoss?: ?$ElementType<Scalars, 'DecimalScalar'>,
    reportingInterval?: ?VatReportingInterval,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    submitUrgencyLevel?: ?ReportSubmitUrgencyLevel,
    total?: ?$ElementType<Scalars, 'DecimalScalar'>,
    unpaidRecords?: ?RecordTypeConnection,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    year: $ElementType<Scalars, 'Int'>,
  |}
|};


export type PnlReportTypeInvoicesWithoutTaxNumberArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};


export type PnlReportTypeUnpaidRecordsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  createdAt?: ?$ElementType<Scalars, 'DateTime'>,
  date_Gte?: ?$ElementType<Scalars, 'Date'>,
  date_Lte?: ?$ElementType<Scalars, 'Date'>,
  dateYear?: ?$ElementType<Scalars, 'Int'>,
  excludeVatPayments?: ?$ElementType<Scalars, 'Boolean'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  id?: ?$ElementType<Scalars, 'ID'>,
  idIn?: ?$ElementType<Scalars, 'String'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
  orderBy?: ?$ElementType<Scalars, 'String'>,
  paymentDateOrDateYearLte?: ?$ElementType<Scalars, 'Int'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  recommendedRecordsForPendingAutoRecord?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
  recordType_In?: ?Array<?$ElementType<Scalars, 'String'>>,
  recurringSettingSource_Isnull?: ?$ElementType<Scalars, 'Boolean'>,
  search?: ?$ElementType<Scalars, 'String'>,
  updatedAt_Gt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Gte?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lt?: ?$ElementType<Scalars, 'DateTime'>,
  updatedAt_Lte?: ?$ElementType<Scalars, 'DateTime'>,
|};

export type ExpenseSummaryType = {|
  __typename?: 'ExpenseSummaryType',
  expenseSummaryLines?: ?Array<?ExpenseSummaryLine>,
  total?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};

export type ExpenseSummaryLine = {|
  __typename?: 'ExpenseSummaryLine',
  category?: ?$ElementType<Scalars, 'String'>,
  deductibleAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  recordIds?: ?Array<?$ElementType<Scalars, 'String'>>,
|};

export type IncomeSummaryType = {|
  __typename?: 'IncomeSummaryType',
  incomeLines?: ?Array<?IncomeLineType>,
  total?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};

export type IncomeLineType = {|
  __typename?: 'IncomeLineType',
  amount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  category?: ?$ElementType<Scalars, 'String'>,
  recordIds?: ?Array<?$ElementType<Scalars, 'String'>>,
|};

export type BusinessCustomerTypeConnection = {|
  __typename?: 'BusinessCustomerTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?BusinessCustomerTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `BusinessCustomerType` and its cursor. */
export type BusinessCustomerTypeEdge = {|
  __typename?: 'BusinessCustomerTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?BusinessCustomerType,
|};

export type DocumentTypeConnection = {|
  __typename?: 'DocumentTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?DocumentTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `DocumentType` and its cursor. */
export type DocumentTypeEdge = {|
  __typename?: 'DocumentTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?DocumentType,
|};

export type ExperimentTypeConnection = {|
  __typename?: 'ExperimentTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?ExperimentTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `ExperimentType` and its cursor. */
export type ExperimentTypeEdge = {|
  __typename?: 'ExperimentTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?ExperimentType,
|};

export type ExperimentType = {|
  ...Node,
  ...{|
    __typename?: 'ExperimentType',
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    name: ExperimentName,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};

export const ExperimentNameValues = Object.freeze({
  /** Bank Account Integration */
  BankAccountIntegration: 'BANK_ACCOUNT_INTEGRATION',
  /** Create You First Record */
  CreateYourFirstRecord: 'CREATE_YOUR_FIRST_RECORD',
  /** Invoicing Tool */
  InvoicingTool: 'INVOICING_TOOL',
  /** New Main Page */
  NewMainPage: 'NEW_MAIN_PAGE',
  /** Onboarding Tour */
  OnboardingTour: 'ONBOARDING_TOUR',
  /** Tax Consultant Button */
  TaxConsultantMenuButton: 'TAX_CONSULTANT_MENU_BUTTON',
  /** Trial For Vat */
  TrialForVatNewFreelancers: 'TRIAL_FOR_VAT_NEW_FREELANCERS'
});


export type ExperimentName = $Values<typeof ExperimentNameValues>;

export type IncomeTaxReportTypeConnection = {|
  __typename?: 'IncomeTaxReportTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?IncomeTaxReportTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `IncomeTaxReportType` and its cursor. */
export type IncomeTaxReportTypeEdge = {|
  __typename?: 'IncomeTaxReportTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?IncomeTaxReportType,
|};

export type InvoicePaymentMethodTypeConnection = {|
  __typename?: 'InvoicePaymentMethodTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?InvoicePaymentMethodTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `InvoicePaymentMethodType` and its cursor. */
export type InvoicePaymentMethodTypeEdge = {|
  __typename?: 'InvoicePaymentMethodTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?InvoicePaymentMethodType,
|};

export type InvoiceSettingsType = {|
  ...Node,
  ...{|
    __typename?: 'InvoiceSettingsType',
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    email?: ?$ElementType<Scalars, 'String'>,
    hasLogo: $ElementType<Scalars, 'Boolean'>,
    headerType?: ?$ElementType<Scalars, 'String'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    invoiceLogo?: ?$ElementType<Scalars, 'String'>,
    invoiceNumberPrefix?: ?$ElementType<Scalars, 'String'>,
    lastInvoiceOrdinalNumber: $ElementType<Scalars, 'Int'>,
    phone?: ?$ElementType<Scalars, 'String'>,
    themeColor?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    website?: ?$ElementType<Scalars, 'String'>,
  |}
|};

export type YearlyConfigType = {|
  ...Node,
  ...{|
    __typename?: 'YearlyConfigType',
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    shouldPayVat?: ?$ElementType<Scalars, 'Boolean'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatReportingInterval?: ?VatReportingInterval,
    year?: ?$ElementType<Scalars, 'Int'>,
  |}
|};

export type PnlReportTypeConnection = {|
  __typename?: 'PNLReportTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?PnlReportTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `PNLReportType` and its cursor. */
export type PnlReportTypeEdge = {|
  __typename?: 'PNLReportTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?PnlReportType,
|};

export const TaxNeedsValues = Object.freeze({
  Invoicing: 'invoicing',
  OldBusiness: 'old_business',
  RegisterAsAFreelancer: 'register_as_a_freelancer',
  Reports: 'reports',
  TaxQuestion: 'tax_question'
});


export type TaxNeeds = $Values<typeof TaxNeedsValues>;

export type TaxOfficeType = {|
  __typename?: 'TaxOfficeType',
  address?: ?$ElementType<Scalars, 'String'>,
  bankAccounts?: ?Array<?$ElementType<Scalars, 'JSONString'>>,
  email?: ?$ElementType<Scalars, 'String'>,
  label?: ?$ElementType<Scalars, 'String'>,
  openingHours?: ?Array<?$ElementType<Scalars, 'String'>>,
  phone?: ?$ElementType<Scalars, 'String'>,
  taxOfficeId?: ?$ElementType<Scalars, 'String'>,
  website?: ?$ElementType<Scalars, 'String'>,
|};

export type TaxRegistrationType = {|
  ...BaseReportInterface,
  ...Node,
  ...{|
    __typename?: 'TaxRegistrationType',
    approvalReceiveDate?: ?$ElementType<Scalars, 'Date'>,
    business?: ?BusinessType,
    confirmationDocument?: ?DocumentType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    data?: ?$ElementType<Scalars, 'JSONString'>,
    firstYearInBusiness?: ?$ElementType<Scalars, 'Int'>,
    hideOnTimeline?: ?$ElementType<Scalars, 'Boolean'>,
    id: $ElementType<Scalars, 'ID'>,
    isCorrection?: ?$ElementType<Scalars, 'Boolean'>,
    isFeatureInTrial?: ?$ElementType<Scalars, 'Boolean'>,
    isFormValid?: ?$ElementType<Scalars, 'Boolean'>,
    isSent?: ?$ElementType<Scalars, 'Boolean'>,
    isTaxOfficeResponseReceived?: ?$ElementType<Scalars, 'Boolean'>,
    pageData?: ?$ElementType<Scalars, 'JSONString'>,
    pagesValidity?: ?$ElementType<Scalars, 'JSONString'>,
    reportedDate?: ?$ElementType<Scalars, 'Date'>,
    requiresSubscription?: ?$ElementType<Scalars, 'Boolean'>,
    sentWithSorted?: ?$ElementType<Scalars, 'Boolean'>,
    shouldChargeVat?: ?$ElementType<Scalars, 'Boolean'>,
    shouldFillSpouseData?: ?$ElementType<Scalars, 'Boolean'>,
    startedSubmissionProcess: $ElementType<Scalars, 'Boolean'>,
    submissionDeadline?: ?$ElementType<Scalars, 'Date'>,
    taxOfficeId?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
    vatNumberRequested?: ?$ElementType<Scalars, 'Boolean'>,
  |}
|};


export type TaxRegistrationTypePageDataArgs = {|
  pageName?: ?$ElementType<Scalars, 'String'>,
|};

export type UnsupportedBankAccountTypeConnection = {|
  __typename?: 'UnsupportedBankAccountTypeConnection',
  count?: ?$ElementType<Scalars, 'Int'>,
  /** Contains the nodes in this connection. */
  edges: Array<?UnsupportedBankAccountTypeEdge>,
  exists?: ?$ElementType<Scalars, 'Boolean'>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `UnsupportedBankAccountType` and its cursor. */
export type UnsupportedBankAccountTypeEdge = {|
  __typename?: 'UnsupportedBankAccountTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?UnsupportedBankAccountType,
|};

export type UnsupportedBankAccountType = {|
  ...Node,
  ...{|
    __typename?: 'UnsupportedBankAccountType',
    bankName: $ElementType<Scalars, 'String'>,
    business: BusinessType,
    createdAt: $ElementType<Scalars, 'DateTime'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    isBusinessAccount?: ?$ElementType<Scalars, 'Boolean'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};

export type VatReportTypeConnection = {|
  __typename?: 'VatReportTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?VatReportTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `VatReportType` and its cursor. */
export type VatReportTypeEdge = {|
  __typename?: 'VatReportTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?VatReportType,
|};

export type YearlyConfigTypeConnection = {|
  __typename?: 'YearlyConfigTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?YearlyConfigTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `YearlyConfigType` and its cursor. */
export type YearlyConfigTypeEdge = {|
  __typename?: 'YearlyConfigTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?YearlyConfigType,
|};

export type ZmReportTypeConnection = {|
  __typename?: 'ZmReportTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?ZmReportTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `ZmReportType` and its cursor. */
export type ZmReportTypeEdge = {|
  __typename?: 'ZmReportTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?ZmReportType,
|};

export const RecordGrossAmountCurrencyValues = Object.freeze({
  /** UAE Dirham */
  Aed: 'AED',
  /** Afghani */
  Afn: 'AFN',
  /** Lek */
  All: 'ALL',
  /** Armenian Dram */
  Amd: 'AMD',
  /** Netherlands Antillian Guilder */
  Ang: 'ANG',
  /** Kwanza */
  Aoa: 'AOA',
  /** Argentine Peso */
  Ars: 'ARS',
  /** Australian Dollar */
  Aud: 'AUD',
  /** Aruban Guilder */
  Awg: 'AWG',
  /** Azerbaijanian Manat */
  Azn: 'AZN',
  /** Convertible Marks */
  Bam: 'BAM',
  /** Barbados Dollar */
  Bbd: 'BBD',
  /** Taka */
  Bdt: 'BDT',
  /** Bulgarian Lev */
  Bgn: 'BGN',
  /** Bahraini Dinar */
  Bhd: 'BHD',
  /** Burundi Franc */
  Bif: 'BIF',
  /** Bermudian Dollar (customarily known as Bermuda Dollar) */
  Bmd: 'BMD',
  /** Brunei Dollar */
  Bnd: 'BND',
  /** Boliviano */
  Bob: 'BOB',
  /** Mvdol */
  Bov: 'BOV',
  /** Brazilian Real */
  Brl: 'BRL',
  /** Bahamian Dollar */
  Bsd: 'BSD',
  /** Bhutanese ngultrum */
  Btn: 'BTN',
  /** Pula */
  Bwp: 'BWP',
  /** Belarussian Ruble */
  Byn: 'BYN',
  /** Belarussian Ruble */
  Byr: 'BYR',
  /** Belize Dollar */
  Bzd: 'BZD',
  /** Canadian Dollar */
  Cad: 'CAD',
  /** Congolese franc */
  Cdf: 'CDF',
  /** WIR Euro */
  Che: 'CHE',
  /** Swiss Franc */
  Chf: 'CHF',
  /** WIR Franc */
  Chw: 'CHW',
  /** Unidad de Fomento */
  Clf: 'CLF',
  /** Chilean peso */
  Clp: 'CLP',
  /** Yuan Renminbi */
  Cny: 'CNY',
  /** Colombian peso */
  Cop: 'COP',
  /** Unidad de Valor Real */
  Cou: 'COU',
  /** Costa Rican Colon */
  Crc: 'CRC',
  /** Cuban convertible peso */
  Cuc: 'CUC',
  /** Cuban Peso */
  Cup: 'CUP',
  /** Cape Verde Escudo */
  Cve: 'CVE',
  /** Czech Koruna */
  Czk: 'CZK',
  /** Djibouti Franc */
  Djf: 'DJF',
  /** Danish Krone */
  Dkk: 'DKK',
  /** Dominican Peso */
  Dop: 'DOP',
  /** Algerian Dinar */
  Dzd: 'DZD',
  /** Egyptian Pound */
  Egp: 'EGP',
  /** Nakfa */
  Ern: 'ERN',
  /** Ethiopian Birr */
  Etb: 'ETB',
  /** Euro */
  Eur: 'EUR',
  /** Fiji Dollar */
  Fjd: 'FJD',
  /** Falkland Islands Pound */
  Fkp: 'FKP',
  /** Pound Sterling */
  Gbp: 'GBP',
  /** Lari */
  Gel: 'GEL',
  /** Ghana Cedi */
  Ghs: 'GHS',
  /** Gibraltar Pound */
  Gip: 'GIP',
  /** Dalasi */
  Gmd: 'GMD',
  /** Guinea Franc */
  Gnf: 'GNF',
  /** Quetzal */
  Gtq: 'GTQ',
  /** Guyana Dollar */
  Gyd: 'GYD',
  /** Hong Kong Dollar */
  Hkd: 'HKD',
  /** Lempira */
  Hnl: 'HNL',
  /** Croatian Kuna */
  Hrk: 'HRK',
  /** Haitian gourde */
  Htg: 'HTG',
  /** Forint */
  Huf: 'HUF',
  /** Rupiah */
  Idr: 'IDR',
  /** New Israeli Sheqel */
  Ils: 'ILS',
  /** Isle of Man Pound */
  Imp: 'IMP',
  /** Indian Rupee */
  Inr: 'INR',
  /** Iraqi Dinar */
  Iqd: 'IQD',
  /** Iranian Rial */
  Irr: 'IRR',
  /** Iceland Krona */
  Isk: 'ISK',
  /** Jamaican Dollar */
  Jmd: 'JMD',
  /** Jordanian Dinar */
  Jod: 'JOD',
  /** Yen */
  Jpy: 'JPY',
  /** Kenyan Shilling */
  Kes: 'KES',
  /** Som */
  Kgs: 'KGS',
  /** Riel */
  Khr: 'KHR',
  /** Comoro Franc */
  Kmf: 'KMF',
  /** North Korean Won */
  Kpw: 'KPW',
  /** Won */
  Krw: 'KRW',
  /** Kuwaiti Dinar */
  Kwd: 'KWD',
  /** Cayman Islands Dollar */
  Kyd: 'KYD',
  /** Tenge */
  Kzt: 'KZT',
  /** Kip */
  Lak: 'LAK',
  /** Lebanese Pound */
  Lbp: 'LBP',
  /** Sri Lanka Rupee */
  Lkr: 'LKR',
  /** Liberian Dollar */
  Lrd: 'LRD',
  /** Lesotho loti */
  Lsl: 'LSL',
  /** Lithuanian Litas */
  Ltl: 'LTL',
  /** Latvian Lats */
  Lvl: 'LVL',
  /** Libyan Dinar */
  Lyd: 'LYD',
  /** Moroccan Dirham */
  Mad: 'MAD',
  /** Moldovan Leu */
  Mdl: 'MDL',
  /** Malagasy Ariary */
  Mga: 'MGA',
  /** Denar */
  Mkd: 'MKD',
  /** Kyat */
  Mmk: 'MMK',
  /** Tugrik */
  Mnt: 'MNT',
  /** Pataca */
  Mop: 'MOP',
  /** Ouguiya */
  Mro: 'MRO',
  /** Mauritius Rupee */
  Mur: 'MUR',
  /** Rufiyaa */
  Mvr: 'MVR',
  /** Malawian Kwacha */
  Mwk: 'MWK',
  /** Mexican peso */
  Mxn: 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv: 'MXV',
  /** Malaysian Ringgit */
  Myr: 'MYR',
  /** Metical */
  Mzn: 'MZN',
  /** Namibian Dollar */
  Nad: 'NAD',
  /** Naira */
  Ngn: 'NGN',
  /** Cordoba Oro */
  Nio: 'NIO',
  /** Norwegian Krone */
  Nok: 'NOK',
  /** Nepalese Rupee */
  Npr: 'NPR',
  /** New Zealand Dollar */
  Nzd: 'NZD',
  /** Rial Omani */
  Omr: 'OMR',
  /** Balboa */
  Pab: 'PAB',
  /** Nuevo Sol */
  Pen: 'PEN',
  /** Kina */
  Pgk: 'PGK',
  /** Philippine Peso */
  Php: 'PHP',
  /** Pakistan Rupee */
  Pkr: 'PKR',
  /** Zloty */
  Pln: 'PLN',
  /** Guarani */
  Pyg: 'PYG',
  /** Qatari Rial */
  Qar: 'QAR',
  /** New Leu */
  Ron: 'RON',
  /** Serbian Dinar */
  Rsd: 'RSD',
  /** Russian Ruble */
  Rub: 'RUB',
  /** Rwanda Franc */
  Rwf: 'RWF',
  /** Saudi Riyal */
  Sar: 'SAR',
  /** Solomon Islands Dollar */
  Sbd: 'SBD',
  /** Seychelles Rupee */
  Scr: 'SCR',
  /** Sudanese Pound */
  Sdg: 'SDG',
  /** Swedish Krona */
  Sek: 'SEK',
  /** Singapore Dollar */
  Sgd: 'SGD',
  /** Saint Helena Pound */
  Shp: 'SHP',
  /** Leone */
  Sll: 'SLL',
  /** Somali Shilling */
  Sos: 'SOS',
  /** Surinam Dollar */
  Srd: 'SRD',
  /** South Sudanese Pound */
  Ssp: 'SSP',
  /** Dobra */
  Std: 'STD',
  /** El Salvador Colon */
  Svc: 'SVC',
  /** Syrian Pound */
  Syp: 'SYP',
  /** Lilangeni */
  Szl: 'SZL',
  /** Baht */
  Thb: 'THB',
  /** Somoni */
  Tjs: 'TJS',
  /** Manat */
  Tmm: 'TMM',
  /** Turkmenistan New Manat */
  Tmt: 'TMT',
  /** Tunisian Dinar */
  Tnd: 'TND',
  /** Paanga */
  Top: 'TOP',
  /** Turkish Lira */
  Try: 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd: 'TTD',
  /** Tuvalu dollar */
  Tvd: 'TVD',
  /** New Taiwan Dollar */
  Twd: 'TWD',
  /** Tanzanian Shilling */
  Tzs: 'TZS',
  /** Hryvnia */
  Uah: 'UAH',
  /** Uganda Shilling */
  Ugx: 'UGX',
  /** US Dollar */
  Usd: 'USD',
  /** US Dollar (Next day) */
  Usn: 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi: 'UYI',
  /** Uruguayan peso */
  Uyu: 'UYU',
  /** Uzbekistan Sum */
  Uzs: 'UZS',
  /** Bolivar Fuerte */
  Vef: 'VEF',
  /** Dong */
  Vnd: 'VND',
  /** Vatu */
  Vuv: 'VUV',
  /** Tala */
  Wst: 'WST',
  /** CFA franc BEAC */
  Xaf: 'XAF',
  /** Silver */
  Xag: 'XAG',
  /** Gold */
  Xau: 'XAU',
  /** Bond Markets Units European Composite Unit (EURCO) */
  Xba: 'XBA',
  /** European Monetary Unit (E.M.U.-6) */
  Xbb: 'XBB',
  /** European Unit of Account 9(E.U.A.-9) */
  Xbc: 'XBC',
  /** European Unit of Account 17(E.U.A.-17) */
  Xbd: 'XBD',
  /** East Caribbean Dollar */
  Xcd: 'XCD',
  /** SDR */
  Xdr: 'XDR',
  /** Gold-Franc */
  Xfo: 'XFO',
  /** UIC-Franc */
  Xfu: 'XFU',
  /** CFA Franc BCEAO */
  Xof: 'XOF',
  /** Palladium */
  Xpd: 'XPD',
  /** CFP Franc */
  Xpf: 'XPF',
  /** Platinum */
  Xpt: 'XPT',
  /** Sucre */
  Xsu: 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts: 'XTS',
  /** ADB Unit of Account */
  Xua: 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx: 'XXX',
  /** Yemeni Rial */
  Yer: 'YER',
  /** Rand */
  Zar: 'ZAR',
  /** Zambian Kwacha */
  Zmk: 'ZMK',
  /** Zambian Kwacha */
  Zmw: 'ZMW',
  /** Zimbabwe Dollar A/06 */
  Zwd: 'ZWD',
  /** Zimbabwe dollar A/09 */
  Zwl: 'ZWL',
  /** Zimbabwe dollar A/08 */
  Zwn: 'ZWN'
});


export type RecordGrossAmountCurrency = $Values<typeof RecordGrossAmountCurrencyValues>;

export type AdvanceVatPaymentDataType = {|
  __typename?: 'AdvanceVatPaymentDataType',
  amount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  recordIds?: ?Array<?$ElementType<Scalars, 'String'>>,
|};

export type TaxRegistrationTypeConnection = {|
  __typename?: 'TaxRegistrationTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?TaxRegistrationTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `TaxRegistrationType` and its cursor. */
export type TaxRegistrationTypeEdge = {|
  __typename?: 'TaxRegistrationTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?TaxRegistrationType,
|};

export type AnnualPayslipTypeConnection = {|
  __typename?: 'AnnualPayslipTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?AnnualPayslipTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `AnnualPayslipType` and its cursor. */
export type AnnualPayslipTypeEdge = {|
  __typename?: 'AnnualPayslipTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?AnnualPayslipType,
|};

export type YearlyChildInfoTypeConnection = {|
  __typename?: 'YearlyChildInfoTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?YearlyChildInfoTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `YearlyChildInfoType` and its cursor. */
export type YearlyChildInfoTypeEdge = {|
  __typename?: 'YearlyChildInfoTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?YearlyChildInfoType,
|};

export type YearlyChildInfoType = {|
  ...Node,
  ...{|
    __typename?: 'YearlyChildInfoType',
    createdAt: $ElementType<Scalars, 'DateTime'>,
    data?: ?$ElementType<Scalars, 'JSONString'>,
    /** The ID of the object. */
  id: $ElementType<Scalars, 'ID'>,
    incomeTaxReport: IncomeTaxReportType,
    name?: ?$ElementType<Scalars, 'String'>,
    updatedAt: $ElementType<Scalars, 'DateTime'>,
  |}
|};

export type IncomeTaxReportPartnerType = {|
  __typename?: 'IncomeTaxReportPartnerType',
  annualPayslips?: ?AnnualPayslipTypeConnection,
  hasIncomeFromEmployment?: ?$ElementType<Scalars, 'Boolean'>,
  incomeTaxReport?: ?IncomeTaxReportType,
  profitFromSelfEmployment?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeAdvancePayments?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeContributionsToPension?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeContributionsToPrivateHealthAndCareInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeContributionsToPublicCareInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeContributionsToPublicHealthInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalEmployeeContributionsToUnemploymentInsurance?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalIncomeFromEmployment?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};


export type IncomeTaxReportPartnerTypeAnnualPayslipsArgs = {|
  after?: ?$ElementType<Scalars, 'String'>,
  before?: ?$ElementType<Scalars, 'String'>,
  first?: ?$ElementType<Scalars, 'Int'>,
  last?: ?$ElementType<Scalars, 'Int'>,
  offset?: ?$ElementType<Scalars, 'Int'>,
|};

export const ExpenseCategoryValues = Object.freeze({
  Advertising: 'advertising',
  BusinessTripAccommodation: 'business_trip_accommodation',
  BusinessTripMealAllowance: 'business_trip_meal_allowance',
  Communication: 'communication',
  Contractors: 'contractors',
  CoronaAid: 'corona_aid',
  Entertainment: 'entertainment',
  Gift: 'gift',
  Insurance: 'insurance',
  LegalAndAccounting: 'legal_and_accounting',
  Materials: 'materials',
  Other: 'other',
  PrivateCarUsage: 'private_car_usage',
  Rent: 'rent',
  Software: 'software',
  Tools: 'tools',
  Training: 'training',
  TransportationTicket: 'transportation_ticket',
  Utilities: 'utilities',
  VatPaymentToTaxOffice: 'vat_payment_to_tax_office'
});


export type ExpenseCategory = $Values<typeof ExpenseCategoryValues>;

export type Payment = {|
  __typename?: 'Payment',
  amount?: ?$ElementType<Scalars, 'Int'>,
  paid?: ?$ElementType<Scalars, 'Boolean'>,
  reason?: ?$ElementType<Scalars, 'String'>,
|};

export type GetLatestDataExportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type GetLatestDataExportPayload = {|
  __typename?: 'GetLatestDataExportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  exportDownloadUrl?: ?$ElementType<Scalars, 'String'>,
  exportFileName?: ?$ElementType<Scalars, 'String'>,
  exportGeneratedAt?: ?$ElementType<Scalars, 'String'>,
|};

export type BusinessTypeConnection = {|
  __typename?: 'BusinessTypeConnection',
  /** Contains the nodes in this connection. */
  edges: Array<?BusinessTypeEdge>,
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
|};

/** A Relay edge containing a `BusinessType` and its cursor. */
export type BusinessTypeEdge = {|
  __typename?: 'BusinessTypeEdge',
  /** A cursor for use in pagination */
  cursor: $ElementType<Scalars, 'String'>,
  /** The item at the end of the edge */
  node?: ?BusinessType,
|};

export type ReportsUnion = AnnualVatReportType | IncomeTaxReportType | PnlReportType | TaxRegistrationType | VatReportType | ZmReportType;

export type Currency = {|
  __typename?: 'Currency',
  code?: ?$ElementType<Scalars, 'String'>,
  name?: ?$ElementType<Scalars, 'String'>,
  symbol?: ?$ElementType<Scalars, 'String'>,
|};

export type TaxServiceBillingDataType = {|
  __typename?: 'TaxServiceBillingDataType',
  netPriceWithoutFee?: ?$ElementType<Scalars, 'DecimalScalar'>,
  serviceType?: ?TaxServiceType,
  sortedFeeGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  sortedFeeNet?: ?$ElementType<Scalars, 'DecimalScalar'>,
  taxAdvisorGrossAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  totalVat?: ?$ElementType<Scalars, 'DecimalScalar'>,
  vatRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};

export type Mutation = {|
  __typename?: 'Mutation',
  BillCustomerForTaxService?: ?BillCustomerForTaxServicePayload,
  CancelTaxServiceBilling?: ?CancelTaxServiceBillingPayload,
  DeleteAnnualPayslip?: ?DeleteAnnualPayslipPayload,
  DeleteAnnualVatReport?: ?DeleteAnnualVatReportPayload,
  DeleteBankConnection?: ?DeleteBankConnectionPayload,
  DeleteBusinessCustomer?: ?DeleteBusinessCustomerPayload,
  DeleteDocument?: ?DeleteDocumentPayload,
  DeleteIncomeTaxReport?: ?DeleteIncomeTaxReportPayload,
  DeleteInvoiceLogo?: ?DeleteInvoiceLogoPayload,
  DeleteInvoicePaymentMethod?: ?DeleteInvoicePaymentMethodPayload,
  DeletePnlReport?: ?DeletePnlReportPayload,
  DeleteRecord?: ?DeleteRecordPayload,
  DeleteTaxRegistration?: ?DeleteTaxRegistrationPayload,
  DeleteUserAccount?: ?DeleteUserAccountPayload,
  DeleteVatReport?: ?DeleteVatReportPayload,
  DeleteYearlyChildInfo?: ?DeleteYearlyChildInfoPayload,
  DeleteZMReport?: ?DeleteZmReportPayload,
  DismissAlert?: ?DismissAlertPayload,
  ExportAccountData?: ?ExportAccountDataPayload,
  ImportDatevFile?: ?ImportDatevFilePayload,
  ImportSpreadsheet?: ?ImportSpreadsheetPayload,
  IntroduceAddCreditCard?: ?IntroduceAddCreditCardPayload,
  IntroduceAnnualPayslip?: ?IntroduceAnnualPayslipPayload,
  IntroduceAnnualReportsStartYear?: ?IntroduceAnnualReportsStartYearPayload,
  IntroduceAnonymousLogin?: ?IntroduceAnonymousLoginPayload,
  IntroduceBankConnection?: ?IntroduceBankConnectionPayload,
  IntroduceBusinessCustomer?: ?IntroduceBusinessCustomerPayload,
  IntroduceBusinessProfile?: ?IntroduceBusinessProfilePayload,
  IntroduceCompletedOnboardingStep?: ?IntroduceCompletedOnboardingStepPayload,
  IntroduceCustomTaxServiceBilling?: ?IntroduceCustomTaxServiceBillingPayload,
  IntroduceDocument?: ?IntroduceDocumentPayload,
  IntroduceIncomeStatementDocument?: ?IntroduceIncomeStatementDocumentPayload,
  IntroduceIncomeStatementPreparationRequest?: ?IntroduceIncomeStatementPreparationRequestPayload,
  IntroduceInvoice?: ?IntroduceInvoicePayload,
  IntroduceInvoiceLogo?: ?IntroduceInvoiceLogoPayload,
  IntroduceInvoicePaymentMethod?: ?IntroduceInvoicePaymentMethodPayload,
  IntroduceInvoiceSettings?: ?IntroduceInvoiceSettingsPayload,
  IntroduceLinking?: ?IntroduceLinkingPayload,
  IntroduceNewSubscriptionPlan?: ?IntroduceNewSubscriptionPlanPayload,
  IntroduceRecord?: ?IntroduceRecordPayload,
  IntroduceReferralCodeReceived?: ?IntroduceReferralCodeReceivedPayload,
  IntroduceSampleDocument?: ?IntroduceSampleDocumentPayload,
  IntroduceSubscriptionCanceled?: ?IntroduceSubscriptionCanceledPayload,
  IntroduceSubscriptionCheckoutSession?: ?IntroduceSubscriptionCheckoutSessionPayload,
  IntroduceSubscriptionResumed?: ?IntroduceSubscriptionResumedPayload,
  IntroduceTaxNeedsOnboardingQuestion?: ?IntroduceTaxNeedsOnboardingQuestionPayload,
  IntroduceTaxRequest?: ?IntroduceTaxRequestPayload,
  IntroduceUnsupportedBankAccount?: ?IntroduceUnsupportedBankAccountPayload,
  IntroduceUpdateCreditCard?: ?IntroduceUpdateCreditCardPayload,
  IntroduceUserSettings?: ?IntroduceUserSettingsPayload,
  IntroduceVatSettings?: ?IntroduceVatSettingsPayload,
  IntroduceYearlyChildInfo?: ?IntroduceYearlyChildInfoPayload,
  InviteFriends?: ?InviteFriendsPayload,
  MarkAutoRecordAsNotPending?: ?MarkAutoRecordAsNotPendingPayload,
  MarkIncomeTaxReportAsSent?: ?MarkIncomeTaxReportAsSentPayload,
  MarkInvoicePaymentMethodAsDefault?: ?MarkInvoicePaymentMethodAsDefaultPayload,
  MarkPnlAsAlreadySent?: ?MarkPnlAsAlreadySentPayload,
  MarkRecordPaymentStatus?: ?MarkRecordPaymentStatusPayload,
  MarkTaxRegistrationAlreadyDeclared?: ?MarkTaxRegistrationAlreadyDeclaredPayload,
  MarkTaxRegistrationApprovalReceived?: ?MarkTaxRegistrationApprovalReceivedPayload,
  MarkZMReportAsAlreadySent?: ?MarkZmReportAsAlreadySentPayload,
  ParseImportSpreadsheet?: ?ParseImportSpreadsheetPayload,
  ReconnectBankConnection?: ?ReconnectBankConnectionPayload,
  RefreshBankConnection?: ?RefreshBankConnectionPayload,
  SaveIncomeTaxPrepayments?: ?SaveIncomeTaxPrepaymentsPayload,
  SavePreviousYearRevenue?: ?SavePreviousYearRevenuePayload,
  SendAnnualVAT?: ?SendAnnualVatPayload,
  SendIncomeTaxReport?: ?SendIncomeTaxReportPayload,
  SendInvoice?: ?SendInvoicePayload,
  SendPNL?: ?SendPnlPayload,
  SendTaxRegistration?: ?SendTaxRegistrationPayload,
  SendVAT?: ?SendVatPayload,
  SendZM?: ?SendZmPayload,
  SignupAffiliateProgram?: ?SignupAffiliateProgramPayload,
  StartTaxRegistrationSubmission?: ?StartTaxRegistrationSubmissionPayload,
  UpdateIncomeTaxReport?: ?UpdateIncomeTaxReportPayload,
  UpdateTaxRegistration?: ?UpdateTaxRegistrationPayload,
|};


export type MutationBillCustomerForTaxServiceArgs = {|
  input: BillCustomerForTaxServiceInput,
|};


export type MutationCancelTaxServiceBillingArgs = {|
  input: CancelTaxServiceBillingInput,
|};


export type MutationDeleteAnnualPayslipArgs = {|
  input: DeleteAnnualPayslipInput,
|};


export type MutationDeleteAnnualVatReportArgs = {|
  input: DeleteAnnualVatReportInput,
|};


export type MutationDeleteBankConnectionArgs = {|
  input: DeleteBankConnectionInput,
|};


export type MutationDeleteBusinessCustomerArgs = {|
  input: DeleteBusinessCustomerInput,
|};


export type MutationDeleteDocumentArgs = {|
  input: DeleteDocumentInput,
|};


export type MutationDeleteIncomeTaxReportArgs = {|
  input: DeleteIncomeTaxReportInput,
|};


export type MutationDeleteInvoiceLogoArgs = {|
  input: DeleteInvoiceLogoInput,
|};


export type MutationDeleteInvoicePaymentMethodArgs = {|
  input: DeleteInvoicePaymentMethodInput,
|};


export type MutationDeletePnlReportArgs = {|
  input: DeletePnlReportInput,
|};


export type MutationDeleteRecordArgs = {|
  input: DeleteRecordInput,
|};


export type MutationDeleteTaxRegistrationArgs = {|
  input: DeleteTaxRegistrationInput,
|};


export type MutationDeleteUserAccountArgs = {|
  input: DeleteUserAccountInput,
|};


export type MutationDeleteVatReportArgs = {|
  input: DeleteVatReportInput,
|};


export type MutationDeleteYearlyChildInfoArgs = {|
  input: DeleteYearlyChildInfoInput,
|};


export type MutationDeleteZmReportArgs = {|
  input: DeleteZmReportInput,
|};


export type MutationDismissAlertArgs = {|
  input: DismissAlertInput,
|};


export type MutationExportAccountDataArgs = {|
  input: ExportAccountDataInput,
|};


export type MutationImportDatevFileArgs = {|
  input: ImportDatevFileInput,
|};


export type MutationImportSpreadsheetArgs = {|
  input: ImportSpreadsheetInput,
|};


export type MutationIntroduceAddCreditCardArgs = {|
  input: IntroduceAddCreditCardInput,
|};


export type MutationIntroduceAnnualPayslipArgs = {|
  input: IntroduceAnnualPayslipInput,
|};


export type MutationIntroduceAnnualReportsStartYearArgs = {|
  input: IntroduceAnnualReportsStartYearInput,
|};


export type MutationIntroduceAnonymousLoginArgs = {|
  input: IntroduceAnonymousLoginInput,
|};


export type MutationIntroduceBankConnectionArgs = {|
  input: IntroduceBankConnectionInput,
|};


export type MutationIntroduceBusinessCustomerArgs = {|
  input: IntroduceBusinessCustomerInput,
|};


export type MutationIntroduceBusinessProfileArgs = {|
  input: IntroduceBusinessProfileInput,
|};


export type MutationIntroduceCompletedOnboardingStepArgs = {|
  input: IntroduceCompletedOnboardingStepInput,
|};


export type MutationIntroduceCustomTaxServiceBillingArgs = {|
  input: IntroduceCustomTaxServiceBillingInput,
|};


export type MutationIntroduceDocumentArgs = {|
  input: IntroduceDocumentInput,
|};


export type MutationIntroduceIncomeStatementDocumentArgs = {|
  input: IntroduceIncomeStatementDocumentInput,
|};


export type MutationIntroduceIncomeStatementPreparationRequestArgs = {|
  input: IntroduceIncomeStatementPreparationRequestInput,
|};


export type MutationIntroduceInvoiceArgs = {|
  input: IntroduceInvoiceInput,
|};


export type MutationIntroduceInvoiceLogoArgs = {|
  input: IntroduceInvoiceLogoInput,
|};


export type MutationIntroduceInvoicePaymentMethodArgs = {|
  input: IntroduceInvoicePaymentMethodInput,
|};


export type MutationIntroduceInvoiceSettingsArgs = {|
  input: IntroduceInvoiceSettingsInput,
|};


export type MutationIntroduceLinkingArgs = {|
  input: IntroduceLinkingInput,
|};


export type MutationIntroduceNewSubscriptionPlanArgs = {|
  input: IntroduceNewSubscriptionPlanInput,
|};


export type MutationIntroduceRecordArgs = {|
  input: IntroduceRecordInput,
|};


export type MutationIntroduceReferralCodeReceivedArgs = {|
  input: IntroduceReferralCodeReceivedInput,
|};


export type MutationIntroduceSampleDocumentArgs = {|
  input: IntroduceSampleDocumentInput,
|};


export type MutationIntroduceSubscriptionCanceledArgs = {|
  input: IntroduceSubscriptionCanceledInput,
|};


export type MutationIntroduceSubscriptionCheckoutSessionArgs = {|
  input: IntroduceSubscriptionCheckoutSessionInput,
|};


export type MutationIntroduceSubscriptionResumedArgs = {|
  input: IntroduceSubscriptionResumedInput,
|};


export type MutationIntroduceTaxNeedsOnboardingQuestionArgs = {|
  input: IntroduceTaxNeedsOnboardingQuestionInput,
|};


export type MutationIntroduceTaxRequestArgs = {|
  input: IntroduceTaxRequestInput,
|};


export type MutationIntroduceUnsupportedBankAccountArgs = {|
  input: IntroduceUnsupportedBankAccountInput,
|};


export type MutationIntroduceUpdateCreditCardArgs = {|
  input: IntroduceUpdateCreditCardInput,
|};


export type MutationIntroduceUserSettingsArgs = {|
  input: IntroduceUserSettingsInput,
|};


export type MutationIntroduceVatSettingsArgs = {|
  input: IntroduceVatSettingsInput,
|};


export type MutationIntroduceYearlyChildInfoArgs = {|
  input: IntroduceYearlyChildInfoInput,
|};


export type MutationInviteFriendsArgs = {|
  input: InviteFriendsInput,
|};


export type MutationMarkAutoRecordAsNotPendingArgs = {|
  input: MarkAutoRecordAsNotPendingInput,
|};


export type MutationMarkIncomeTaxReportAsSentArgs = {|
  input: MarkIncomeTaxReportAsSentInput,
|};


export type MutationMarkInvoicePaymentMethodAsDefaultArgs = {|
  input: MarkInvoicePaymentMethodAsDefaultInput,
|};


export type MutationMarkPnlAsAlreadySentArgs = {|
  input: MarkPnlAsAlreadySentInput,
|};


export type MutationMarkRecordPaymentStatusArgs = {|
  input: MarkRecordPaymentStatusInput,
|};


export type MutationMarkTaxRegistrationAlreadyDeclaredArgs = {|
  input: MarkTaxRegistrationAlreadyDeclaredInput,
|};


export type MutationMarkTaxRegistrationApprovalReceivedArgs = {|
  input: MarkTaxRegistrationApprovalReceivedInput,
|};


export type MutationMarkZmReportAsAlreadySentArgs = {|
  input: MarkZmReportAsAlreadySentInput,
|};


export type MutationParseImportSpreadsheetArgs = {|
  input: ParseImportSpreadsheetInput,
|};


export type MutationReconnectBankConnectionArgs = {|
  input: ReconnectBankConnectionInput,
|};


export type MutationRefreshBankConnectionArgs = {|
  input: RefreshBankConnectionInput,
|};


export type MutationSaveIncomeTaxPrepaymentsArgs = {|
  input: SaveIncomeTaxPrepaymentsInput,
|};


export type MutationSavePreviousYearRevenueArgs = {|
  input: SavePreviousYearRevenueInput,
|};


export type MutationSendAnnualVatArgs = {|
  input: SendAnnualVatInput,
|};


export type MutationSendIncomeTaxReportArgs = {|
  input: SendIncomeTaxReportInput,
|};


export type MutationSendInvoiceArgs = {|
  input: SendInvoiceInput,
|};


export type MutationSendPnlArgs = {|
  input: SendPnlInput,
|};


export type MutationSendTaxRegistrationArgs = {|
  input: SendTaxRegistrationInput,
|};


export type MutationSendVatArgs = {|
  input: SendVatInput,
|};


export type MutationSendZmArgs = {|
  input: SendZmInput,
|};


export type MutationSignupAffiliateProgramArgs = {|
  input: SignupAffiliateProgramInput,
|};


export type MutationStartTaxRegistrationSubmissionArgs = {|
  input: StartTaxRegistrationSubmissionInput,
|};


export type MutationUpdateIncomeTaxReportArgs = {|
  input: UpdateIncomeTaxReportInput,
|};


export type MutationUpdateTaxRegistrationArgs = {|
  input: UpdateTaxRegistrationInput,
|};

export type BillCustomerForTaxServiceInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  serviceBillingId: $ElementType<Scalars, 'ID'>,
  serviceDate: $ElementType<Scalars, 'Date'>,
|};

export type BillCustomerForTaxServicePayload = {|
  __typename?: 'BillCustomerForTaxServicePayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  serviceBilling?: ?TaxServiceBillingType,
|};

export type CancelTaxServiceBillingInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  serviceBillingId: $ElementType<Scalars, 'ID'>,
|};

export type CancelTaxServiceBillingPayload = {|
  __typename?: 'CancelTaxServiceBillingPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  serviceBilling?: ?TaxServiceBillingType,
|};

export type DeleteAnnualPayslipInput = {|
  annualPayslipId: $ElementType<Scalars, 'ID'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteAnnualPayslipPayload = {|
  __typename?: 'DeleteAnnualPayslipPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  deletedAnnualPayslipId?: ?$ElementType<Scalars, 'ID'>,
|};

export type DeleteAnnualVatReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeleteAnnualVatReportPayload = {|
  __typename?: 'DeleteAnnualVatReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteBankConnectionInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  connectionId: $ElementType<Scalars, 'ID'>,
|};

export type DeleteBankConnectionPayload = {|
  __typename?: 'DeleteBankConnectionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteBusinessCustomerInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  customerId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteBusinessCustomerPayload = {|
  __typename?: 'DeleteBusinessCustomerPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  deletedCustomerId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteDocumentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  documentId: $ElementType<Scalars, 'ID'>,
|};

export type DeleteDocumentPayload = {|
  __typename?: 'DeleteDocumentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteIncomeTaxReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeleteIncomeTaxReportPayload = {|
  __typename?: 'DeleteIncomeTaxReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteInvoiceLogoInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteInvoiceLogoPayload = {|
  __typename?: 'DeleteInvoiceLogoPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  invoiceLogo?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteInvoicePaymentMethodInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  paymentMethodId: $ElementType<Scalars, 'String'>,
|};

export type DeleteInvoicePaymentMethodPayload = {|
  __typename?: 'DeleteInvoicePaymentMethodPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  defaultPaymentMethod?: ?InvoicePaymentMethodType,
  deletedPaymentMethodId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeletePnlReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeletePnlReportPayload = {|
  __typename?: 'DeletePnlReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteRecordInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  recordId: $ElementType<Scalars, 'ID'>,
|};

export type DeleteRecordPayload = {|
  __typename?: 'DeleteRecordPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  deletedRecordId?: ?$ElementType<Scalars, 'ID'>,
|};

export type DeleteTaxRegistrationInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeleteTaxRegistrationPayload = {|
  __typename?: 'DeleteTaxRegistrationPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteUserAccountInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteUserAccountPayload = {|
  __typename?: 'DeleteUserAccountPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteVatReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeleteVatReportPayload = {|
  __typename?: 'DeleteVatReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DeleteYearlyChildInfoInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  yearlyChildInfoId: $ElementType<Scalars, 'ID'>,
|};

export type DeleteYearlyChildInfoPayload = {|
  __typename?: 'DeleteYearlyChildInfoPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  deletedYearlyChildInfoId?: ?$ElementType<Scalars, 'ID'>,
|};

export type DeleteZmReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  id: $ElementType<Scalars, 'String'>,
|};

export type DeleteZmReportPayload = {|
  __typename?: 'DeleteZMReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type DismissAlertInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  name: $ElementType<Scalars, 'String'>,
|};

export type DismissAlertPayload = {|
  __typename?: 'DismissAlertPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type ExportAccountDataInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type ExportAccountDataPayload = {|
  __typename?: 'ExportAccountDataPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  exportId?: ?$ElementType<Scalars, 'String'>,
|};

export type ImportDatevFileInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document: $ElementType<Scalars, 'String'>,
  inputChannel: InputChannelEnum,
|};

export type ImportDatevFilePayload = {|
  __typename?: 'ImportDatevFilePayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  expensesApproved?: ?$ElementType<Scalars, 'Int'>,
  expensesPendingApproval?: ?$ElementType<Scalars, 'Int'>,
  incomeRecordsApproved?: ?$ElementType<Scalars, 'Int'>,
  incomeRecordsPendingApproval?: ?$ElementType<Scalars, 'Int'>,
|};

export type ImportSpreadsheetInput = {|
  amountColumn: $ElementType<Scalars, 'Int'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  currencyColumn: $ElementType<Scalars, 'Int'>,
  dateColumn: $ElementType<Scalars, 'Int'>,
  dateDayFirst: $ElementType<Scalars, 'Boolean'>,
  descriptionColumns?: ?Array<?$ElementType<Scalars, 'Int'>>,
  document: $ElementType<Scalars, 'String'>,
  documentKey: $ElementType<Scalars, 'String'>,
  headerRow: $ElementType<Scalars, 'Int'>,
  importType: ImportType,
  inputChannel: InputChannelEnum,
  worksheetIndex: $ElementType<Scalars, 'Int'>,
|};

export const ImportTypeValues = Object.freeze({
  Expenses: 'expenses',
  Income: 'income',
  IncomeAndExpenses: 'income_and_expenses'
});


export type ImportType = $Values<typeof ImportTypeValues>;

export type ImportSpreadsheetPayload = {|
  __typename?: 'ImportSpreadsheetPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAddCreditCardInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  stripePaymentMethodId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAddCreditCardPayload = {|
  __typename?: 'IntroduceAddCreditCardPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAnnualPayslipInput = {|
  amounts: $ElementType<Scalars, 'JSONString'>,
  annualPayslipId?: ?$ElementType<Scalars, 'ID'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  endDate?: ?$ElementType<Scalars, 'Date'>,
  incomeTaxReportYear: $ElementType<Scalars, 'ID'>,
  isMainPartner: $ElementType<Scalars, 'Boolean'>,
  startDate?: ?$ElementType<Scalars, 'Date'>,
  taxClass?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAnnualPayslipPayload = {|
  __typename?: 'IntroduceAnnualPayslipPayload',
  annualPayslip?: ?AnnualPayslipType,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAnnualReportsStartYearInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  startYear: $ElementType<Scalars, 'Int'>,
|};

export type IntroduceAnnualReportsStartYearPayload = {|
  __typename?: 'IntroduceAnnualReportsStartYearPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAnonymousLoginInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceAnonymousLoginPayload = {|
  __typename?: 'IntroduceAnonymousLoginPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  token?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceBankConnectionInput = {|
  bankName: $ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isBusinessAccount: $ElementType<Scalars, 'Boolean'>,
  returnTo: $ElementType<Scalars, 'String'>,
|};

export type IntroduceBankConnectionPayload = {|
  __typename?: 'IntroduceBankConnectionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  redirectUrl?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceBusinessCustomerInput = {|
  address: $ElementType<Scalars, 'JSONString'>,
  businessName?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  customerId?: ?$ElementType<Scalars, 'String'>,
  email?: ?$ElementType<Scalars, 'String'>,
  firstName?: ?$ElementType<Scalars, 'String'>,
  isPrivatePerson: $ElementType<Scalars, 'Boolean'>,
  lastName?: ?$ElementType<Scalars, 'String'>,
  vatNumber?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceBusinessCustomerPayload = {|
  __typename?: 'IntroduceBusinessCustomerPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  customer?: ?BusinessCustomerType,
|};

export type IntroduceBusinessProfileInput = {|
  address?: ?$ElementType<Scalars, 'JSONString'>,
  businessLegalType?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  companyName?: ?$ElementType<Scalars, 'String'>,
  isSelfEmployedBeforeRegistrationYear?: ?$ElementType<Scalars, 'Boolean'>,
  name?: ?$ElementType<Scalars, 'String'>,
  profession?: ?$ElementType<Scalars, 'String'>,
  registeredTaxState?: ?$ElementType<Scalars, 'String'>,
  selfEmploymentEndDate?: ?$ElementType<Scalars, 'Date'>,
  selfEmploymentStartDate?: ?$ElementType<Scalars, 'Date'>,
  taxNumber?: ?$ElementType<Scalars, 'String'>,
  vatNumber?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceBusinessProfilePayload = {|
  __typename?: 'IntroduceBusinessProfilePayload',
  business?: ?BusinessType,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceCompletedOnboardingStepInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  stepName?: ?OnboardingStepsEnum,
|};

export const OnboardingStepsEnumValues = Object.freeze({
  CreateFirstInvoice: 'create_first_invoice',
  DataImport: 'data_import',
  DedicatedTaxAdvisor: 'dedicated_tax_advisor',
  Expense: 'expense',
  ExpenseOverview: 'expense_overview',
  GetToKnowPersonalTaxAdvisor: 'get_to_know_personal_tax_advisor',
  Income: 'income',
  LearnAboutTaxes: 'learn_about_taxes',
  RegisterAsAFreelancer: 'register_as_a_freelancer',
  Reports: 'reports',
  TaxGuides: 'tax_guides',
  TaxQuestionDedicatedTaxAdvisor: 'tax_question_dedicated_tax_advisor',
  TaxesPageTour: 'taxes_page_tour'
});


export type OnboardingStepsEnum = $Values<typeof OnboardingStepsEnumValues>;

export type IntroduceCompletedOnboardingStepPayload = {|
  __typename?: 'IntroduceCompletedOnboardingStepPayload',
  business?: ?BusinessType,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceCustomTaxServiceBillingInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  description: $ElementType<Scalars, 'String'>,
  netPrice: $ElementType<Scalars, 'DecimalScalar'>,
|};

export type IntroduceCustomTaxServiceBillingPayload = {|
  __typename?: 'IntroduceCustomTaxServiceBillingPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  serviceBilling?: ?TaxServiceBillingType,
|};

export type IntroduceDocumentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document: $ElementType<Scalars, 'JSONString'>,
  fileName?: ?$ElementType<Scalars, 'String'>,
  inputChannel: InputChannelEnum,
  markAutoRecordPending?: ?$ElementType<Scalars, 'Boolean'>,
  recordId?: ?$ElementType<Scalars, 'String'>,
  recordType?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceDocumentPayload = {|
  __typename?: 'IntroduceDocumentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
|};

export type IntroduceIncomeStatementDocumentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document: $ElementType<Scalars, 'JSONString'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type IntroduceIncomeStatementDocumentPayload = {|
  __typename?: 'IntroduceIncomeStatementDocumentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type IntroduceIncomeStatementPreparationRequestInput = {|
  autoResponse: $ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  messageBody: $ElementType<Scalars, 'String'>,
  netPrice: $ElementType<Scalars, 'DecimalScalar'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type IntroduceIncomeStatementPreparationRequestPayload = {|
  __typename?: 'IntroduceIncomeStatementPreparationRequestPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type IntroduceInvoiceInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  currency?: ?$ElementType<Scalars, 'String'>,
  customerId: $ElementType<Scalars, 'String'>,
  date?: ?$ElementType<Scalars, 'String'>,
  description?: ?$ElementType<Scalars, 'String'>,
  document: $ElementType<Scalars, 'JSONString'>,
  dueDate?: ?$ElementType<Scalars, 'Date'>,
  editInvoiceId?: ?$ElementType<Scalars, 'String'>,
  headerType?: ?$ElementType<Scalars, 'String'>,
  invoiceNumber?: ?$ElementType<Scalars, 'String'>,
  invoiceOrdinalNumber?: ?$ElementType<Scalars, 'Int'>,
  isServiceOrGoods?: ?SaleType,
  isTaxNumberMissing?: ?$ElementType<Scalars, 'Boolean'>,
  languageCode?: ?Languages,
  lineItems?: ?Array<?InvoiceLineItemInputType>,
  paymentAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  paymentMethodId?: ?$ElementType<Scalars, 'String'>,
  paymentMonth?: ?$ElementType<Scalars, 'Date'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  personalNote?: ?$ElementType<Scalars, 'String'>,
  serviceDateFrom?: ?$ElementType<Scalars, 'Date'>,
  serviceDateUntil?: ?$ElementType<Scalars, 'Date'>,
  themeColor?: ?$ElementType<Scalars, 'String'>,
  vatExemptionParagraph?: ?VatExemptionParagraph,
  vatRate?: ?$ElementType<Scalars, 'Float'>,
|};

export type InvoiceLineItemInputType = {|
  description?: ?$ElementType<Scalars, 'String'>,
  quantity?: ?$ElementType<Scalars, 'DecimalScalar'>,
  total?: ?$ElementType<Scalars, 'DecimalScalar'>,
  unit?: ?ItemUnit,
  unitPrice?: ?$ElementType<Scalars, 'DecimalScalar'>,
  vatRate?: ?$ElementType<Scalars, 'DecimalScalar'>,
|};

export type IntroduceInvoicePayload = {|
  __typename?: 'IntroduceInvoicePayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  invoice?: ?InvoiceType,
|};

export type IntroduceInvoiceLogoInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  logo: $ElementType<Scalars, 'String'>,
|};

export type IntroduceInvoiceLogoPayload = {|
  __typename?: 'IntroduceInvoiceLogoPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  invoiceLogo?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceInvoicePaymentMethodInput = {|
  accountNumber?: ?$ElementType<Scalars, 'String'>,
  bic?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  email?: ?$ElementType<Scalars, 'String'>,
  iban?: ?$ElementType<Scalars, 'String'>,
  name?: ?$ElementType<Scalars, 'String'>,
  paymentMethodId?: ?$ElementType<Scalars, 'String'>,
  paymentMethodType?: ?PaymentMethod,
  text?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceInvoicePaymentMethodPayload = {|
  __typename?: 'IntroduceInvoicePaymentMethodPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  paymentMethod?: ?InvoicePaymentMethodType,
|};

export type IntroduceInvoiceSettingsInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  email?: ?$ElementType<Scalars, 'String'>,
  invoiceNumberPrefix?: ?$ElementType<Scalars, 'String'>,
  phone?: ?$ElementType<Scalars, 'String'>,
  website?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceInvoiceSettingsPayload = {|
  __typename?: 'IntroduceInvoiceSettingsPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  invoiceSettings?: ?InvoiceSettingsType,
|};

export type IntroduceLinkingInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  linkToRecordId: $ElementType<Scalars, 'String'>,
  pendingAutoRecordId: $ElementType<Scalars, 'ID'>,
|};

export type IntroduceLinkingPayload = {|
  __typename?: 'IntroduceLinkingPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  deletedRecordId?: ?$ElementType<Scalars, 'ID'>,
  pendingAutoRecordId?: ?$ElementType<Scalars, 'ID'>,
  record?: ?RecordType,
|};

export type IntroduceNewSubscriptionPlanInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  plan?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceNewSubscriptionPlanPayload = {|
  __typename?: 'IntroduceNewSubscriptionPlanPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceRecordInput = {|
  assetLifetimeValue?: ?$ElementType<Scalars, 'Int'>,
  businessTripMealAccommodationCountry?: ?$ElementType<Scalars, 'String'>,
  category?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  counterPartyCountry?: ?$ElementType<Scalars, 'String'>,
  counterPartyVatNumber?: ?$ElementType<Scalars, 'String'>,
  currency: $ElementType<Scalars, 'String'>,
  date?: ?$ElementType<Scalars, 'Date'>,
  description?: ?$ElementType<Scalars, 'String'>,
  documentId?: ?$ElementType<Scalars, 'String'>,
  expectedLocalVatRate?: ?$ElementType<Scalars, 'String'>,
  expenseAttributionToVatExemptRevenue?: ?ExpenseAttributionToVatExemptRevenue,
  flatRateExpenseEndDate?: ?$ElementType<Scalars, 'Date'>,
  flatRateExpenseStartDate?: ?$ElementType<Scalars, 'Date'>,
  grossAmount: $ElementType<Scalars, 'DecimalScalar'>,
  isCustomerPrivatePerson?: ?$ElementType<Scalars, 'Boolean'>,
  isHomeOffice?: ?$ElementType<Scalars, 'DecimalScalar'>,
  isOfficeMaintenance?: ?$ElementType<Scalars, 'Boolean'>,
  isServiceOrGoods?: ?$ElementType<Scalars, 'String'>,
  netDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
  otherTaxesCharged?: ?$ElementType<Scalars, 'Boolean'>,
  paymentMonth?: ?$ElementType<Scalars, 'Date'>,
  paymentStatus?: ?$ElementType<Scalars, 'String'>,
  pendingAutoRecordId?: ?$ElementType<Scalars, 'ID'>,
  privateCarDistanceDriven?: ?$ElementType<Scalars, 'Int'>,
  privateCarDriveToWorkTotalDays?: ?$ElementType<Scalars, 'Int'>,
  privateCarUsageType?: ?$ElementType<Scalars, 'String'>,
  recordId?: ?$ElementType<Scalars, 'String'>,
  recordType: $ElementType<Scalars, 'String'>,
  recurringSettingSource?: ?$ElementType<Scalars, 'String'>,
  repeatInterval?: ?$ElementType<Scalars, 'String'>,
  reverseChargeApply?: ?$ElementType<Scalars, 'Boolean'>,
  reverseChargeNetAmount?: ?$ElementType<Scalars, 'DecimalScalar'>,
  vat?: ?$ElementType<Scalars, 'JSONString'>,
  vatDeductiblePortion?: ?$ElementType<Scalars, 'DecimalScalar'>,
  vatExemptionParagraph?: ?VatExemptionParagraph,
  vatPaymentPeriodInterval?: ?VatReportingInterval,
|};

export type IntroduceRecordPayload = {|
  __typename?: 'IntroduceRecordPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  record?: ?RecordType,
|};

export type IntroduceReferralCodeReceivedInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  referralCode: $ElementType<Scalars, 'String'>,
|};

export type IntroduceReferralCodeReceivedPayload = {|
  __typename?: 'IntroduceReferralCodeReceivedPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceSampleDocumentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  recordType: $ElementType<Scalars, 'String'>,
|};

export type IntroduceSampleDocumentPayload = {|
  __typename?: 'IntroduceSampleDocumentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
|};

export type IntroduceSubscriptionCanceledInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  reasonText?: ?$ElementType<Scalars, 'String'>,
  reasonType: UnsubscribeReason,
|};

export const UnsubscribeReasonValues = Object.freeze({
  NoLongerFreelancer: 'no_longer_freelancer',
  Other: 'other',
  SwitchToAnotherService: 'switch_to_another_service',
  SwitchToDifferentPlan: 'switch_to_different_plan',
  TooExpensive: 'too_expensive'
});


export type UnsubscribeReason = $Values<typeof UnsubscribeReasonValues>;

export type IntroduceSubscriptionCanceledPayload = {|
  __typename?: 'IntroduceSubscriptionCanceledPayload',
  canceledSubscription?: ?Subscription,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceSubscriptionCheckoutSessionInput = {|
  cancelUrl: $ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  plan: $ElementType<Scalars, 'String'>,
  successUrl: $ElementType<Scalars, 'String'>,
|};

export type IntroduceSubscriptionCheckoutSessionPayload = {|
  __typename?: 'IntroduceSubscriptionCheckoutSessionPayload',
  checkoutSessionId?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceSubscriptionResumedInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceSubscriptionResumedPayload = {|
  __typename?: 'IntroduceSubscriptionResumedPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceTaxNeedsOnboardingQuestionInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxNeeds: TaxNeeds,
|};

export type IntroduceTaxNeedsOnboardingQuestionPayload = {|
  __typename?: 'IntroduceTaxNeedsOnboardingQuestionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceTaxRequestInput = {|
  autoResponse?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  messageBody?: ?$ElementType<Scalars, 'String'>,
  type: TaxServiceType,
|};

export type IntroduceTaxRequestPayload = {|
  __typename?: 'IntroduceTaxRequestPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceUnsupportedBankAccountInput = {|
  bankName: $ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isBusinessAccount: $ElementType<Scalars, 'Boolean'>,
|};

export type IntroduceUnsupportedBankAccountPayload = {|
  __typename?: 'IntroduceUnsupportedBankAccountPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceUpdateCreditCardInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  stripePaymentMethodId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceUpdateCreditCardPayload = {|
  __typename?: 'IntroduceUpdateCreditCardPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceUserSettingsInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  languageCode: $ElementType<Scalars, 'String'>,
|};

export type IntroduceUserSettingsPayload = {|
  __typename?: 'IntroduceUserSettingsPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type IntroduceVatSettingsInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  shouldPayVat: $ElementType<Scalars, 'Boolean'>,
  vatExemptionParagraph?: ?VatExemptionParagraph,
  vatReportingInterval?: ?$ElementType<Scalars, 'String'>,
  vatReportsStartDate?: ?$ElementType<Scalars, 'Date'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type IntroduceVatSettingsPayload = {|
  __typename?: 'IntroduceVatSettingsPayload',
  business?: ?BusinessType,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  yearlyConfig?: ?YearlyConfigType,
  yearlyConfigEdge?: ?YearlyConfigTypeEdge,
|};

export type IntroduceYearlyChildInfoInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  data: $ElementType<Scalars, 'JSONString'>,
  incomeTaxReportYear: $ElementType<Scalars, 'Int'>,
  yearlyChildInfoId?: ?$ElementType<Scalars, 'ID'>,
|};

export type IntroduceYearlyChildInfoPayload = {|
  __typename?: 'IntroduceYearlyChildInfoPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  yearlyChildInfo?: ?YearlyChildInfoType,
|};

export type InviteFriendsInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  emails?: ?Array<?$ElementType<Scalars, 'String'>>,
|};

export type InviteFriendsPayload = {|
  __typename?: 'InviteFriendsPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type MarkAutoRecordAsNotPendingInput = {|
  autoRecordId: $ElementType<Scalars, 'ID'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  shouldDeleteRecurringSetting?: ?$ElementType<Scalars, 'Boolean'>,
|};

export type MarkAutoRecordAsNotPendingPayload = {|
  __typename?: 'MarkAutoRecordAsNotPendingPayload',
  autoRecordId?: ?$ElementType<Scalars, 'ID'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type MarkIncomeTaxReportAsSentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type MarkIncomeTaxReportAsSentPayload = {|
  __typename?: 'MarkIncomeTaxReportAsSentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type MarkInvoicePaymentMethodAsDefaultInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  paymentMethodId: $ElementType<Scalars, 'String'>,
|};

export type MarkInvoicePaymentMethodAsDefaultPayload = {|
  __typename?: 'MarkInvoicePaymentMethodAsDefaultPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  newDefaultPaymentMethod?: ?InvoicePaymentMethodType,
  previousDefaultPaymentMethod?: ?InvoicePaymentMethodType,
|};

export type MarkPnlAsAlreadySentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type MarkPnlAsAlreadySentPayload = {|
  __typename?: 'MarkPnlAsAlreadySentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  pnlReport?: ?PnlReportType,
|};

export type MarkRecordPaymentStatusInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  markPaid?: ?$ElementType<Scalars, 'Boolean'>,
  paymentMonth?: ?$ElementType<Scalars, 'Date'>,
  recordId: $ElementType<Scalars, 'ID'>,
|};

export type MarkRecordPaymentStatusPayload = {|
  __typename?: 'MarkRecordPaymentStatusPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  record?: ?RecordType,
|};

export type MarkTaxRegistrationAlreadyDeclaredInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxNumber?: ?$ElementType<Scalars, 'String'>,
  taxState?: ?$ElementType<Scalars, 'String'>,
|};

export type MarkTaxRegistrationAlreadyDeclaredPayload = {|
  __typename?: 'MarkTaxRegistrationAlreadyDeclaredPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxRegistration?: ?TaxRegistrationType,
|};

export type MarkTaxRegistrationApprovalReceivedInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  profession: $ElementType<Scalars, 'String'>,
  taxNumber: $ElementType<Scalars, 'String'>,
|};

export type MarkTaxRegistrationApprovalReceivedPayload = {|
  __typename?: 'MarkTaxRegistrationApprovalReceivedPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxRegistration?: ?TaxRegistrationType,
|};

export type MarkZmReportAsAlreadySentInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  reportedPeriodStartDate: $ElementType<Scalars, 'Date'>,
|};

export type MarkZmReportAsAlreadySentPayload = {|
  __typename?: 'MarkZMReportAsAlreadySentPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  zmReport?: ?ZmReportType,
|};

export type ParseImportSpreadsheetInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document: $ElementType<Scalars, 'String'>,
  inputChannel: InputChannelEnum,
|};

export type ParseImportSpreadsheetPayload = {|
  __typename?: 'ParseImportSpreadsheetPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  documentKey?: ?$ElementType<Scalars, 'String'>,
  workSheets?: ?Array<?WorkSheetType>,
|};

export type WorkSheetType = {|
  __typename?: 'WorkSheetType',
  columnsInfo?: ?Array<?ColumnInfoType>,
  name?: ?$ElementType<Scalars, 'String'>,
  rows?: ?$ElementType<Scalars, 'JSONString'>,
|};

export type ColumnInfoType = {|
  __typename?: 'ColumnInfoType',
  date?: ?DateColumnSelection,
|};

export const DateColumnSelectionValues = Object.freeze({
  DayFirst: 'day_first',
  MonthFirst: 'month_first',
  Unknown: 'unknown'
});


export type DateColumnSelection = $Values<typeof DateColumnSelectionValues>;

export type ReconnectBankConnectionInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  connectionId: $ElementType<Scalars, 'ID'>,
  returnTo: $ElementType<Scalars, 'String'>,
|};

export type ReconnectBankConnectionPayload = {|
  __typename?: 'ReconnectBankConnectionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  redirectUrl?: ?$ElementType<Scalars, 'String'>,
|};

export type RefreshBankConnectionInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  connectionId: $ElementType<Scalars, 'ID'>,
  returnTo: $ElementType<Scalars, 'String'>,
|};

export type RefreshBankConnectionPayload = {|
  __typename?: 'RefreshBankConnectionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  redirectUrl?: ?$ElementType<Scalars, 'String'>,
|};

export type SaveIncomeTaxPrepaymentsInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxPrepaymentsUpdate: $ElementType<Scalars, 'JSONString'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type SaveIncomeTaxPrepaymentsPayload = {|
  __typename?: 'SaveIncomeTaxPrepaymentsPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type SavePreviousYearRevenueInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  revenue: $ElementType<Scalars, 'DecimalScalar'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type SavePreviousYearRevenuePayload = {|
  __typename?: 'SavePreviousYearRevenuePayload',
  annualVatReport?: ?AnnualVatReportType,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type SendAnnualVatInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun?: ?$ElementType<Scalars, 'Boolean'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type SendAnnualVatPayload = {|
  __typename?: 'SendAnnualVATPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  vatReport?: ?AnnualVatReportType,
|};

export type SendIncomeTaxReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun?: ?$ElementType<Scalars, 'Boolean'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type SendIncomeTaxReportPayload = {|
  __typename?: 'SendIncomeTaxReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type SendInvoiceInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  email: $ElementType<Scalars, 'String'>,
  invoiceId: $ElementType<Scalars, 'ID'>,
  isTest?: ?$ElementType<Scalars, 'Boolean'>,
  message: $ElementType<Scalars, 'String'>,
  sendCopy?: ?$ElementType<Scalars, 'Boolean'>,
  subject: $ElementType<Scalars, 'String'>,
|};

export type SendInvoicePayload = {|
  __typename?: 'SendInvoicePayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  invoice?: ?InvoiceType,
|};

export type SendPnlInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun?: ?$ElementType<Scalars, 'Boolean'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type SendPnlPayload = {|
  __typename?: 'SendPNLPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  pnlReport?: ?PnlReportType,
|};

export type SendTaxRegistrationInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun: $ElementType<Scalars, 'Boolean'>,
|};

export type SendTaxRegistrationPayload = {|
  __typename?: 'SendTaxRegistrationPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  taxRegistration?: ?TaxRegistrationType,
|};

export type SendVatInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun?: ?$ElementType<Scalars, 'Boolean'>,
  reportedPeriodStartDate: $ElementType<Scalars, 'Date'>,
|};

export type SendVatPayload = {|
  __typename?: 'SendVATPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  vatReport?: ?VatReportType,
|};

export type SendZmInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  isTestRun?: ?$ElementType<Scalars, 'Boolean'>,
  reportedPeriodStartDate: $ElementType<Scalars, 'Date'>,
|};

export type SendZmPayload = {|
  __typename?: 'SendZMPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  document?: ?DocumentType,
  zmReport?: ?ZmReportType,
|};

export type SignupAffiliateProgramInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type SignupAffiliateProgramPayload = {|
  __typename?: 'SignupAffiliateProgramPayload',
  affiliateReferralLink?: ?$ElementType<Scalars, 'String'>,
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type StartTaxRegistrationSubmissionInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
|};

export type StartTaxRegistrationSubmissionPayload = {|
  __typename?: 'StartTaxRegistrationSubmissionPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxRegistration?: ?TaxRegistrationType,
|};

export type UpdateIncomeTaxReportInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  data: $ElementType<Scalars, 'JSONString'>,
  isValid: $ElementType<Scalars, 'Boolean'>,
  pageName: $ElementType<Scalars, 'String'>,
  year: $ElementType<Scalars, 'Int'>,
|};

export type UpdateIncomeTaxReportPayload = {|
  __typename?: 'UpdateIncomeTaxReportPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  incomeTaxReport?: ?IncomeTaxReportType,
|};

export type UpdateTaxRegistrationInput = {|
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  data: $ElementType<Scalars, 'JSONString'>,
  isValid: $ElementType<Scalars, 'Boolean'>,
  pageName: $ElementType<Scalars, 'String'>,
|};

export type UpdateTaxRegistrationPayload = {|
  __typename?: 'UpdateTaxRegistrationPayload',
  clientMutationId?: ?$ElementType<Scalars, 'String'>,
  taxRegistration?: ?TaxRegistrationType,
|};
